<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import Loader from "../components/loader";
import api from "@/axios";
import moment from "moment/moment";
import Multiselect from "@vueform/multiselect";
import DropZone from "@/components/widgets/dropZonePlanilha.vue";
import {ref} from "vue";
import {
  GridComponent, ColumnsDirective, ColumnDirective,
  Page, Filter, Toolbar
} from '@syncfusion/ej2-vue-grids';
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "Tabela Base Cotação de Frete ELK",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    DropZone, Layout, PageHeader, Loader, Multiselect,
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
    'e-column': ColumnDirective,
  },
  setup() {
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0]
    };
    return { dropzoneFile, drop};
  },
  provide: {
    grid: [Page, Filter, Toolbar ]
  },
  data() {
    return {
      toolbar: [
        { text: 'Search', tooltipText: 'Pesquisar' }
      ],

      txPesoData: {},
      showModalTxPeso: false,
      submittedTxPeso: false,
      criarNovaFxPesoTxPeso: false,
      submittedFxPesoTxPeso: false,
      txPesoFxPesoData: {},


      criarNovaFxCepPeso: false,

      submittedBaseGlobalTde: false,
      baseGlobalTdeData: {},
      showModalBaseGlobalTde: false,

      submittedBaseGlobalTrt: false,
      baseGlobalTrtData: {},
      showModalBaseGlobalTrt: false,

      submittedBaseTrt: false,
      baseTrtData: {},
      showModalBaseTrt: false,

      submittedBaseTda: false,
      baseTdaData: {},
      showModalBaseTda: false,

      submittedBaseTde: false,
      baseTdeData: {},
      showModalBaseTde: false,

      pageSetsBases: {
        pageSize: 20,
        currentPage: 1,
        totalRecordsCount: 0,
        pageSizes: ['20', '100', '200']
      },

      pageSetsTrts: {
        pageSize: 20,
        currentPage: 1,
        totalRecordsCount: 0,
        pageSizes: ['20', '100', '200']
      },

      pageSetsTdas: {
        pageSize: 20,
        currentPage: 1,
        totalRecordsCount: 0,
        pageSizes: ['20', '100', '200']
      },

      pageSetsTdes: {
        pageSize: 20,
        currentPage: 1,
        totalRecordsCount: 0,
        pageSizes: ['20', '100', '200']
      },

      pageSetsAdics: {
        pageSize: 20,
        currentPage: 1,
        totalRecordsCount: 0,
        pageSizes: ['20', '100', '200']
      },

      pageSetsCepsPesos: {
        pageSize: 20,
        currentPage: 1,
        totalRecordsCount: 0,
        pageSizes: ['20', '100', '200']
      },

      showModalTaxaAdic: false,
      showModalCepPeso: false,
      submittedTaxaAdic: false,
      submittedCepPeso: false,
      submittedCepPesoFxPeso: false,
      taxaAdicData: {},
      cepPesoData: {},
      cepPesoFxPesoData: {},
      cepPesoFxsPesosData: {},


      baseOrigemData: {},
      showModalBaseOrigem: false,
      submittedBaseOrigem: false,
      freteCotaOrigens: null,


      baseRegraData: {},
      showModalBaseRegra: false,
      submittedBaseRegra: false,

      visibleRegioes: true,
      visibleEstados: false,

      regiaoFaixasCeps: [],
      regiaoSelect: null,
      regSelBrasil: null,
      regSelSudeste: null,
      regSelSul: null,
      regSelNordeste: null,
      regSelNorte: null,
      regSelCentrooeste: null,
      regSelEstSP: null,
      regSelEstSPCap: null,
      regSelEstSPAreaMetr: null,
      regSelEstSPLitoral: null,
      regSelEstSPInterior: null,
      regSelEstRJ: null,
      regSelEstRJCap: null,
      regSelEstRJAreaMetr: null,
      regSelEstRJInterior: null,
      regSelEstES: null,
      regSelEstESCap: null,
      regSelEstESInterior: null,
      regSelEstMG: null,
      regSelEstMGCap: null,
      regSelEstMGAreaMetr: null,
      regSelEstMGInterior: null,
      regSelEstBA: null,
      regSelEstBACap: null,
      regSelEstBAAreaMetr: null,
      regSelEstBAInterior: null,
      regSelEstSE: null,
      regSelEstSECap: null,
      regSelEstSEInterior: null,
      regSelEstPE: null,
      regSelEstPECap: null,
      regSelEstPEAreaMetr: null,
      regSelEstPEInterior: null,
      regSelEstAL: null,
      regSelEstALCap: null,
      regSelEstALInterior: null,
      regSelEstPB: null,
      regSelEstPBCap: null,
      regSelEstPBInterior: null,
      regSelEstRN: null,
      regSelEstRNCap: null,
      regSelEstRNInterior: null,
      regSelEstCE: null,
      regSelEstCECap: null,
      regSelEstCEAreaMetr: null,
      regSelEstCEInterior: null,
      regSelEstPI: null,
      regSelEstPICap: null,
      regSelEstPIInterior: null,
      regSelEstMA: null,
      regSelEstMACap: null,
      regSelEstMAInterior: null,
      regSelEstPA: null,
      regSelEstPACap: null,
      regSelEstPAAreaMetr: null,
      regSelEstPAInterior: null,
      regSelEstAP: null,
      regSelEstAPCap: null,
      regSelEstAPInterior: null,
      regSelEstAM: null,
      regSelEstAMCap: null,
      regSelEstAMInterior: null,
      regSelEstRR: null,
      regSelEstRRCap: null,
      regSelEstRRInterior: null,
      regSelEstAC: null,
      regSelEstACCap: null,
      regSelEstACInterior: null,
      regSelEstDF: null,
      regSelEstDFCap: null,
      regSelEstDFInterior: null,
      regSelEstGO: null,
      regSelEstGOCap: null,
      regSelEstGOInterior: null,
      regSelEstTO: null,
      regSelEstTOCap: null,
      regSelEstTOInterior: null,
      regSelEstMT: null,
      regSelEstMTCap: null,
      regSelEstMTInterior: null,
      regSelEstRO: null,
      regSelEstROCap: null,
      regSelEstROInterior: null,
      regSelEstMS: null,
      regSelEstMSCap: null,
      regSelEstMSInterior: null,
      regSelEstPR: null,
      regSelEstPRCap: null,
      regSelEstPRAreaMetr: null,
      regSelEstPRInterior: null,
      regSelEstSC: null,
      regSelEstSCCap: null,
      regSelEstSCAreaMetr: null,
      regSelEstSCInterior: null,
      regSelEstRS: null,
      regSelEstRSCap: null,
      regSelEstRSAreaMetr: null,
      regSelEstRSInterior: null,

      insereCepManual: true,

      showModalRegraDesc: false,
      freteCotaRegraData: {},
      freteCotaRegrasData: null,
      submittedRegra: false,
      regiaoRegra: null,

      submittedImpPlan: false,
      showModalImpPlan: false,

      showModalEmpresa: null,
      freteCotaBaseEmprData: {},
      freteCotaBaseEmprsData: null,
      submittedEmprData: false,

      dtListPesqEmpresa: null,
      seguimentoData: null,
      dtListPesqSegto: null,

      showModalBaseTrtTda: false,
      submittedBaseTrtTda: false,
      baseTrtTdaData: {},

      updating: true,
      errosValid: null,
      freteCotaBaseTabData: {
        id: 0,
        status: 'A'
      },
      freteCotaBasesData: null,

      freteCotaTrtsData: null,
      freteCotaTdasData: null,
      freteCotaTdesData: null,
      freteCotaAdicsData: null,
      freteCotaCepPesosData: null,

      idData: '',
      submitted: false,

      title: "Tabela Base Cotação de Frete ELK",
      items: [
        {
          text: "Tabelas Base",
          href: "/cotacaofretesbaseelk/list",
        },
        {
          text: "Tabela Base Cotação de Frete ELK",
          active: true,
        },
      ],


    };
  },

  methods: {

    exportarVtex(){
      console.log('exportarVtex')
      this.updating = true
      api.get(`${getBaseUrl()}api/fretetabexvtex`, {
        params: this.freteCotaBaseTabData._idtabela
      }).then(response => {
        console.log('responseExportVtex')
        // console.log(response.data)

        if(response.data.error){
          Swal.fire({
            position: "center",
            icon: "error",
            title: response.data.error,
            showConfirmButton: false,
            timer: 3000
          })
          this.updating = false
          return
        }

        const linkSource = `data:application/xls;base64,${response.data.base64}`
        const downloadLink = document.createElement("a")
        const fileName = `tabela_econoPro_${this.idData}.xls`
        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
        this.updating = false
      })
    },


    novaFxPesoTxPeso(){
      console.log('novaFxPesoTxPeso')
      if (!Array.isArray(this.txPesoData.txpesos)) {
        this.txPesoData.txpesos = [];
      }
      this.txPesoData.txpesos.push({});
    },

    confBaseGlobalTrt(){
      console.log('confBaseGlobalTrt')
      this.updating = true
      this.showModalBaseGlobalTrt = false
      this.baseGlobalTrtData._idtabela = this.freteCotaBaseTabData._idtabela
      api.post(`${getBaseUrl()}api/fretecotabasetrtgbl`, {
        baseGlobalTrtData: this.baseGlobalTrtData
      }).then((res) => {
        console.log('res post ocorfinal')
        console.log(res)
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informação salva com sucesso",
          showConfirmButton: false,
          timer: 1500
        }).then(
            this.carregarDados
        )
      })


    },

    confBaseGlobalTde(){
      console.log('confBaseGlobalTde')
      this.updating = true
      this.showModalBaseGlobalTde = false
      this.baseGlobalTdeData._idtabela = this.freteCotaBaseTabData._idtabela
      api.post(`${getBaseUrl()}api/fretecotabasetdegbl`, {
        baseGlobalTdeData: this.baseGlobalTdeData
      }).then((res) => {
        console.log('res post ocorfinal')
        console.log(res)
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informação salva com sucesso",
          showConfirmButton: false,
          timer: 1500
        }).then(
            this.carregarDados
        )
      })
    },


    altGlobalTrt(){
      console.log('altGlobalTrt')
      this.submittedBaseGlobalTrt = false
      this.baseGlobalTrtData = {}
      this.showModalBaseGlobalTrt = true
    },

    altGlobalTde(){
      console.log('altGlobalTde')
      this.submittedBaseGlobalTde = false
      this.baseGlobalTdeData = {}
      this.showModalBaseGlobalTde = true
    },

    editarOrigem(data){
      console.log('editarOrigem')
      console.log(data)
      this.baseOrigemData = data
      this.showModalBaseOrigem = true
    },

    editarTxPeso(data){
      console.log('editarTxPeso')
      console.log(data)
      this.txPesoData = data
      this.showModalTxPeso = true
    },

    editarRegra(data){
      console.log('editarRegra')
      console.log(data)
      this.baseRegraData = data
      this.showModalBaseRegra = true
    },


    deletarOrigem(cepini){
      console.log('deletarOrigem')
      console.log(this.freteCotaBaseTabData.origens)
      console.log(cepini)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de CEP de Origem",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.freteCotaBaseTabData.origens = this.freteCotaBaseTabData.origens.filter(
              origem => origem.cepini !== cepini
          );
        }
      })
    },

    deletarTxPeso(cepini){
      console.log('deletartxPeso')
      console.log(this.freteCotaBaseTabData.txpesos)
      console.log(cepini)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Taxa de Peso",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.freteCotaBaseTabData.txpesos = this.freteCotaBaseTabData.txpesos.filter(
              txpeso => txpeso.cepini !== cepini
          );
        }
      })
    },


    deletarRegra(cepini){
      console.log('deletarRegra')
      console.log(this.freteCotaBaseTabData.regras)
      console.log(cepini)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Regra de Desconto",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.freteCotaBaseTabData.regras = this.freteCotaBaseTabData.regras.filter(
              regra => regra.cepini !== cepini
          );
        }
      })
    },


    atualizaBasesList(page, pageSize, search){
      console.log('atualizaBasesList')
      this.updating = true
      const paramsReq = {
        'idTabela': this.freteCotaBaseTabData._idtabela,
        'page': page,
        'pageSize': pageSize,
        'search': search,
      }
      api.get(`${getBaseUrl()}api/fretecotabasetabbaseselk`, {
        params: paramsReq
      }).then(response => {
        console.log('response.bases')
        console.log(response.data)
        this.freteCotaBasesData = {
          result: response.data[0],
          count: response.data[1],
        }
        this.pageSetsBases.totalRecordsCount = response.data[1]
        this.pageSetsBases.currentPage = page
        this.pageSetsBases.pageSize = pageSize
      })
      this.updating = false
    },


    atualizaTrtsList(page, pageSize, search){
      console.log('atualizaTrtsList')
      this.updating = true
      const paramsReq = {
        'idTabela': this.freteCotaBaseTabData._idtabela,
        'page': page,
        'pageSize': pageSize,
        'search': search,
      }
      api.get(`${getBaseUrl()}api/fretecotabasetabtrtselk`, {
        params: paramsReq
      }).then(response => {
        console.log('response.bases')
        console.log(response.data)
        this.freteCotaTrtsData = {
          result: response.data[0],
          count: response.data[1],
        }
        this.pageSetsTrts.totalRecordsCount = response.data[1]
        this.pageSetsTrts.currentPage = page
        this.pageSetsTrts.pageSize = pageSize
      })
      this.updating = false
    },


    atualizaTdasList(page, pageSize, search){
      console.log('atualizaTdasList')
      this.updating = true
      const paramsReq = {
        'idTabela': this.freteCotaBaseTabData._idtabela,
        'page': page,
        'pageSize': pageSize,
        'search': search,
      }
      api.get(`${getBaseUrl()}api/fretecotabasetabtdaselk`, {
        params: paramsReq
      }).then(response => {
        console.log('response.bases')
        console.log(response.data)
        this.freteCotaTdasData = {
          result: response.data[0],
          count: response.data[1],
        }
        this.pageSetsTdas.totalRecordsCount = response.data[1]
        this.pageSetsTdas.currentPage = page
        this.pageSetsTdas.pageSize = pageSize
      })
      this.updating = false
    },


    atualizaTdesList(page, pageSize, search){
      console.log('atualizaTdesList')
      this.updating = true
      const paramsReq = {
        'idTabela': this.freteCotaBaseTabData._idtabela,
        'page': page,
        'pageSize': pageSize,
        'search': search,
      }
      api.get(`${getBaseUrl()}api/fretecotabasetabtdeselk`, {
        params: paramsReq
      }).then(response => {
        console.log('response.bases')
        console.log(response.data)
        this.freteCotaTdesData = {
          result: response.data[0],
          count: response.data[1],
        }
        this.pageSetsTdes.totalRecordsCount = response.data[1]
        this.pageSetsTdes.currentPage = page
        this.pageSetsTdes.pageSize = pageSize
      })
      this.updating = false
    },


    atualizaAdicsList(page, pageSize, search){
      console.log('atualizaAdicsList')
      this.updating = true
      const paramsReq = {
        'idTabela': this.freteCotaBaseTabData._idtabela,
        'page': page,
        'pageSize': pageSize,
        'search': search,
      }
      api.get(`${getBaseUrl()}api/fretecotabasetabadicselk`, {
        params: paramsReq
      }).then(response => {
        console.log('response.bases')
        console.log(response.data)
        this.freteCotaAdicsData = {
          result: response.data[0],
          count: response.data[1],
        }
        this.pageSetsAdics.totalRecordsCount = response.data[1]
        this.pageSetsAdics.currentPage = page
        this.pageSetsAdics.pageSize = pageSize
      })
      this.updating = false
    },

    atualizaCepPesosList(page, pageSize, search){
      console.log('atualizaCepPesosList')
      this.updating = true
      const paramsReq = {
        'idTabela': this.freteCotaBaseTabData._idtabela,
        'page': page,
        'pageSize': pageSize,
        'search': search,
      }
      api.get(`${getBaseUrl()}api/fretecotabasecepesoselk`, {
        params: paramsReq
      }).then(response => {
        console.log('response.bases')
        console.log(response.data)
        this.freteCotaCepPesosData = {
          result: response.data[0],
          count: response.data[1],
        }
        this.pageSetsCepsPesos.totalRecordsCount = response.data[1]
        this.pageSetsCepsPesos.currentPage = page
        this.pageSetsCepsPesos.pageSize = pageSize
      })
      this.updating = false
    },


    dataBoundBases: function() {
      this.$refs.dataGridBases.autoFitColumns([])
    },



    recDblClickBase(evt){
      console.log('recDblClickBase_0')
      console.log(evt.rowData);
      const routeData = this.$router.resolve(`/cotacaofretesbaseelk/editar/${evt.rowData._id}`)
      window.open(routeData.href, '_blank')
    },


    recDblClickTrt(evt){
      console.log('recDblClickTrt')
      console.log(evt.rowData);
      this.baseTrtData = evt.rowData
      this.showModalBaseTrt = true
    },

    recDblClickTda(evt){
      console.log('recDblClickTda')
      console.log(evt.rowData);
      this.baseTdaData = evt.rowData
      this.showModalBaseTda = true
    },

    recDblClickTde(evt){
      console.log('recDblClickTde')
      console.log(evt.rowData);
      this.baseTdeData = evt.rowData
      this.showModalBaseTde = true
    },

    recDblClickAdic(evt){
      console.log('recDblClickAdic')
      console.log(evt.rowData);
      this.taxaAdicData = evt.rowData
      this.showModalTaxaAdic = true
    },

    recDblClickCepPeso(evt){
      console.log('recDblClickCepPeso')
      console.log(evt.rowData);
      this.cepPesoData = evt.rowData
      this.showModalCepPeso = true
    },


    changePageBases(args){
      console.log('changePageBases')
      // console.log(args)
      if (args.currentPage || args.searchString){
        console.log(args)
        this.atualizaBasesList(args.currentPage, args.pageSize, args.searchString ?? null)
      }
    },

    changePageTrts(args){
      console.log('changePageTrts')
      if (args.currentPage || args.searchString){
        console.log(args)
        this.atualizaTrtsList(args.currentPage, args.pageSize, args.searchString ?? null)
      }
    },

    changePageTdas(args){
      console.log('changePageTdas')
      if (args.currentPage || args.searchString){
        console.log(args)
        this.atualizaTdasList(args.currentPage, args.pageSize, args.searchString ?? null)
      }
    },

    changePageTdes(args){
      console.log('changePageTdes')
      if (args.currentPage || args.searchString){
        console.log(args)
        this.atualizaTdesList(args.currentPage, args.pageSize, args.searchString ?? null)
      }
    },

    changePageAdics(args){
      console.log('changePageAdics')
      if (args.currentPage || args.searchString){
        console.log(args)
        this.atualizaAdicsList(args.currentPage, args.pageSize, args.searchString ?? null)
      }
    },

    changePageCepPesos(args){
      console.log('changePageCepPesos')
      if (args.currentPage || args.searchString){
        console.log(args)
        this.atualizaCepPesosList(args.currentPage, args.pageSize, args.searchString ?? null)
      }
    },


    exclCePeso(idData){
      console.log('exclCepPeso')
      this.showModalCepPeso = false
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Taxa CEP " + idData,
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/fretecotacepesoelk`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informação excluída com sucesso",
              showConfirmButton: false,
              timer: 1500
            }).then(
                this.carregarDados
            )
          })
        }
      })
    },


    exclTaxaAdic(idData){
      console.log('exclTaxaAdic')
      this.showModalTaxaAdic = false
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Taxa Adicional " + idData,
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/fretecotabaseadic`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informação excluída com sucesso",
              showConfirmButton: false,
              timer: 1500
            }).then(
                this.carregarDados
            )
          })
        }
      })

    },


    exclBaseTrt(idData){
      console.log('exclBaseTrt')
      this.showModalBaseTrt = false
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de TRT" + idData,
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/fretecotabasetrtelk`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informação excluída com sucesso",
              showConfirmButton: false,
              timer: 1500
            }).then(
                this.carregarDados
            )
          })
        }
      })
    },

    exclBaseTda(idData){
      console.log('exclBaseTda')
      this.showModalBaseTda = false
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de TDA " + idData,
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/fretecotabasetdaelk`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informação excluída com sucesso",
              showConfirmButton: false,
              timer: 1500
            }).then(
                this.carregarDados
            )
          })
        }
      })
    },


    exclBaseTde(idData){
      console.log('exclBaseTde')
      this.showModalBaseTde = false
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de TDE " + idData,
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/fretecotabasetdeelk`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informação excluída com sucesso",
              showConfirmButton: false,
              timer: 1500
            }).then(
                this.carregarDados
            )
          })
        }
      })
    },


    novaOrigem(){
      console.log('novaOrigem')
      this.baseOrigemData = {}
      this.submittedBaseOrigem = false
      this.showModalBaseOrigem = true
    },


    confBaseOrigem() {
      console.log('confBaseOrigem')
      console.log(this.baseOrigemData)
      this.submittedBaseOrigem = true
      if (this.baseOrigemData.cepini !== null && this.baseOrigemData.cepfim) {
        this.showModalBaseOrigem = false
        if (!Array.isArray(this.freteCotaBaseTabData.origens)) {
          this.freteCotaBaseTabData.origens = [];
        }
        const jaExiste = this.freteCotaBaseTabData.origens.some(
            item => item.cepini === this.baseOrigemData.cepini
        )
        console.log('jaExiste')
        console.log(jaExiste)
        if (!jaExiste || jaExiste === false) {
          console.log('vaic_criar')
          this.freteCotaBaseTabData.origens.push({ ...this.baseOrigemData })
        }
        console.log('this.freteCotaBaseTabData.origens')
        console.log(this.freteCotaBaseTabData.origens)
      }
    },

    confTxPeso() {
      console.log('confTxPeso')
      console.log(this.txPesoData)
      this.submittedTxPeso = true
      if (this.txPesoData.cepini !== null && this.txPesoData.cepfim) {
        this.showModalTxPeso = false
        if (!Array.isArray(this.freteCotaBaseTabData.txpesos)) {
          this.freteCotaBaseTabData.txpesos = [];
        }
        const jaExiste = this.freteCotaBaseTabData.txpesos.some(
            item => item.cepini === this.txPesoData.cepini
        )
        console.log('jaExiste')
        console.log(jaExiste)
        if (!jaExiste || jaExiste === false) {
          console.log('vaic_criar')
          this.freteCotaBaseTabData.txpesos.push({ ...this.txPesoData })
        }
        console.log('this.freteCotaBaseTabData.txpesos')
        console.log(this.freteCotaBaseTabData.txpesos)
      }
    },

    onRowDblClickOrigem(row) {
      console.log('onRowDblClickOrigem')
      console.log(row.data)
      this.baseOrigemData = row.data
      this.showModalBaseOrigem = true
    },


    novaTrtTde(){
      console.log('novaTrtTde')
      this.baseTrtTdaData = {}
      this.showModalBaseTrtTda = true
    },

    novaBaseTrt(){
      console.log('novaBaseTrt')
      this.baseTrtData = {}
      this.submittedBaseTrt = false
      this.showModalBaseTrt = true
    },

    novaBaseTda(){
      console.log('novaBaseTda')
      this.baseTdaData = {}
      this.submittedBaseTda = false
      this.showModalBaseTda = true
    },


    changeRegiaoBR() {
      console.log('changeRegiaoBR')
      console.log(this.regSelBrasil)
      this.insereCepManual = false
      this.regiaoFaixasCeps = []

      if (this.regSelBrasil) {
        this.regSelSudeste = null
        this.regSelSul = null
        this.regSelNorte = null
        this.regSelNordeste = null
        this.regSelCentrooeste = null
        this.regSelEstSPCap = null
        this.regSelEstSPAreaMetr = null
        this.regSelEstSPLitoral = null
        this.regSelEstSPInterior = null
        this.regSelEstRJCap = null
        this.regSelEstRJAreaMetr = null
        this.regSelEstRJInterior = null
        this.regSelEstESCap = null
        this.regSelEstESInterior = null
        this.regSelEstMGCap = null
        this.regSelEstMGAreaMetr = null
        this.regSelEstMGInterior = null
        this.regSelEstBACap = null
        this.regSelEstBAAreaMetr = null
        this.regSelEstBAInterior = null
        this.regSelEstSECap = null
        this.regSelEstSEInterior = null
        this.regSelEstPECap = null
        this.regSelEstPEAreaMetr = null
        this.regSelEstPEInterior = null
        this.regSelEstALCap = null
        this.regSelEstALInterior = null
        this.regSelEstPBCap = null
        this.regSelEstPBInterior = null
        this.regSelEstRNCap = null
        this.regSelEstRNInterior = null
        this.regSelEstCECap = null
        this.regSelEstCEAreaMetr = null
        this.regSelEstCEInterior = null
        this.regSelEstPICap = null
        this.regSelEstPIInterior = null
        this.regSelEstMACap = null
        this.regSelEstMAInterior = null
        this.regSelEstPACap = null
        this.regSelEstPAAreaMetr = null
        this.regSelEstPAInterior = null
        this.regSelEstAPCap = null
        this.regSelEstAPInterior = null
        this.regSelEstAMCap = null
        this.regSelEstAMInterior = null
        this.regSelEstRRCap = null
        this.regSelEstRRInterior = null
        this.regSelEstACCap = null
        this.regSelEstACInterior = null
        this.regSelEstDFCap = null
        this.regSelEstDFInterior = null
        this.regSelEstGOCap = null
        this.regSelEstGOInterior = null
        this.regSelEstTOCap = null
        this.regSelEstTOInterior = null
        this.regSelEstMTCap = null
        this.regSelEstMTInterior = null
        this.regSelEstROCap = null
        this.regSelEstROInterior = null
        this.regSelEstMSCap = null
        this.regSelEstMSInterior = null
        this.regSelEstPRCap = null
        this.regSelEstPRAreaMetr = null
        this.regSelEstPRInterior = null
        this.regSelEstSCCap = null
        this.regSelEstSCAreaMetr = null
        this.regSelEstSCInterior = null
        this.regSelEstRSCap = null
        this.regSelEstRSAreaMetr = null
        this.regSelEstRSInterior = null

        this.regiaoFaixasCeps.push({
          'id': 1,
          'cepini': '00000000',
          'cepfim': '99999999',
        })
        this.visibleEstados = false
      } else {
        this.insereCepManual = true
      }
    },


    changeRegiao(){
      console.log('changeRegiao')
      this.insereCepManual = false
      this.regiaoFaixasCeps = []

      if (this.regSelSudeste || this.regSelSul || this.regSelNorte || this.regSelNordeste || this.regSelCentrooeste){
        this.regSelBrasil = null

        this.regSelEstSPCap = null
        this.regSelEstSPAreaMetr = null
        this.regSelEstSPLitoral = null
        this.regSelEstSPInterior = null
        this.regSelEstRJCap = null
        this.regSelEstRJAreaMetr = null
        this.regSelEstRJInterior = null
        this.regSelEstESCap = null
        this.regSelEstESInterior = null
        this.regSelEstMGCap = null
        this.regSelEstMGAreaMetr = null
        this.regSelEstMGInterior = null
        this.regSelEstBACap = null
        this.regSelEstBAAreaMetr = null
        this.regSelEstBAInterior = null
        this.regSelEstSECap = null
        this.regSelEstSEInterior = null
        this.regSelEstPECap = null
        this.regSelEstPEAreaMetr = null
        this.regSelEstPEInterior = null
        this.regSelEstALCap = null
        this.regSelEstALInterior = null
        this.regSelEstPBCap = null
        this.regSelEstPBInterior = null
        this.regSelEstRNCap = null
        this.regSelEstRNInterior = null
        this.regSelEstCECap = null
        this.regSelEstCEAreaMetr = null
        this.regSelEstCEInterior = null
        this.regSelEstPICap = null
        this.regSelEstPIInterior = null
        this.regSelEstMACap = null
        this.regSelEstMAInterior = null
        this.regSelEstPACap = null
        this.regSelEstPAAreaMetr = null
        this.regSelEstPAInterior = null
        this.regSelEstAPCap = null
        this.regSelEstAPInterior = null
        this.regSelEstAMCap = null
        this.regSelEstAMInterior = null
        this.regSelEstRRCap = null
        this.regSelEstRRInterior = null
        this.regSelEstACCap = null
        this.regSelEstACInterior = null
        this.regSelEstDFCap = null
        this.regSelEstDFInterior = null
        this.regSelEstGOCap = null
        this.regSelEstGOInterior = null
        this.regSelEstTOCap = null
        this.regSelEstTOInterior = null
        this.regSelEstMTCap = null
        this.regSelEstMTInterior = null
        this.regSelEstROCap = null
        this.regSelEstROInterior = null
        this.regSelEstMSCap = null
        this.regSelEstMSInterior = null
        this.regSelEstPRCap = null
        this.regSelEstPRAreaMetr = null
        this.regSelEstPRInterior = null
        this.regSelEstSCCap = null
        this.regSelEstSCAreaMetr = null
        this.regSelEstSCInterior = null
        this.regSelEstRSCap = null
        this.regSelEstRSAreaMetr = null
        this.regSelEstRSInterior = null
        this.visibleEstados = false

      }


      if (!this.regSelBrasil && !this.regSelSudeste && !this.regSelSul && !this.regSelNorte && !this.regSelNordeste && !this.regSelCentrooeste
          && !this.regSelEstSPCap && !this.regSelEstSPAreaMetr && !this.regSelEstSPLitoral && !this.regSelEstSPInterior
          && !this.regSelEstRJCap && !this.regSelEstRJAreaMetr && !this.regSelEstRJInterior && !this.regSelEstESCap && !this.regSelEstESInterior
          && !this.regSelEstMGCap && !this.regSelEstMGAreaMetr && !this.regSelEstMGInterior && !this.regSelEstBACap && !this.regSelEstBAAreaMetr && !this.regSelEstBAInterior
          && !this.regSelEstSECap && !this.regSelEstSEInterior && !this.regSelEstPECap && !this.regSelEstPEAreaMetr && !this.regSelEstPEInterior
          && !this.regSelEstALCap && !this.regSelEstALInterior && !this.regSelEstPBCap && !this.regSelEstPBInterior
          && !this.regSelEstRNCap && !this.regSelEstRNInterior && !this.regSelEstCECap && !this.regSelEstCEAreaMetr && !this.regSelEstCEInterior
          && !this.regSelEstPICap && !this.regSelEstPIInterior && !this.regSelEstMACap && !this.regSelEstMAInterior
          && !this.regSelEstPACap && !this.regSelEstPAAreaMetr && !this.regSelEstPAInterior
          && !this.regSelEstAPCap && !this.regSelEstAPInterior && !this.regSelEstAMCap && !this.regSelEstAMInterior
          && !this.regSelEstRRCap && !this.regSelEstRRInterior && !this.regSelEstACCap && !this.regSelEstACInterior
          && !this.regSelEstDFCap && !this.regSelEstDFInterior && !this.regSelEstGOCap && !this.regSelEstGOInterior
          && !this.regSelEstTOCap && !this.regSelEstTOInterior && !this.regSelEstMTCap && !this.regSelEstMTInterior
          && !this.regSelEstROCap && !this.regSelEstROInterior && !this.regSelEstMSCap && !this.regSelEstMSInterior
          && !this.regSelEstPRCap && !this.regSelEstPRAreaMetr && !this.regSelEstPRInterior && !this.regSelEstSCCap && !this.regSelEstSCAreaMetr && !this.regSelEstSCInterior
          && !this.regSelEstRSCap && !this.regSelEstRSAreaMetr && !this.regSelEstRSInterior
      ) {
        this.insereCepManual = true
      }

      if (this.regSelSudeste) {
        this.regiaoFaixasCeps.push({
          'id': 1,
          'cepini': '01000000',
          'cepfim': '39999999',
        })
      }
      if (this.regSelSul) {
        this.regiaoFaixasCeps.push({
          'id': 2,
          'cepini': '80000000',
          'cepfim': '99999999',
        })
      }
      if (this.regSelNordeste) {
        this.regiaoFaixasCeps.push({
          'id': 3,
          'cepini': '40000000',
          'cepfim': '65999999',
        })
      }
      if (this.regSelNorte) {
        this.regiaoFaixasCeps.push({
          'id': 4,
          'cepini': '66000000',
          'cepfim': '69999999',
        })
        this.regiaoFaixasCeps.push({
          'id': 5,
          'cepini': '76800000',
          'cepfim': '77999999',
        })
      }
      if (this.regSelCentrooeste) {
        this.regiaoFaixasCeps.push({
          'id': 6,
          'cepini': '70000000',
          'cepfim': '76799999',
        })
        this.regiaoFaixasCeps.push({
          'id': 7,
          'cepini': '78000000',
          'cepfim': '79999999',
        })
      }

    },

    changeEstado(){
      console.log('changeEstado')
      this.insereCepManual = false
      this.regiaoFaixasCeps = []

      if (this.regSelEstSPCap || this.regSelEstSPAreaMetr || this.regSelEstSPLitoral ||
          this.regSelEstSPInterior || this.regSelEstRJCap || this.regSelEstRJAreaMetr ||
          this.regSelEstRJInterior  || this.regSelEstESCap  || this.regSelEstESInterior ||
          this.regSelEstMGCap || this.regSelEstMGAreaMetr || this.regSelEstMGInterior ||
          this.regSelEstBACap || this.regSelEstBAAreaMetr || this.regSelEstBAInterior ||
          this.regSelEstSECap || this.regSelEstSEInterior || this.regSelEstPECap ||
          this.regSelEstPEAreaMetr || this.regSelEstPEInterior || this.regSelEstALCap ||
          this.regSelEstALInterior || this.regSelEstPBCap || this.regSelEstPBInterior ||
          this.regSelEstRNCap || this.regSelEstRNInterior || this.regSelEstCECap ||
          this.regSelEstCEAreaMetr || this.regSelEstCEInterior || this.regSelEstPICap ||
          this.regSelEstPIInterior || this.regSelEstMACap || this.regSelEstMAInterior ||
          this.regSelEstPACap || this.regSelEstPAAreaMetr || this.regSelEstPAInterior ||
          this.regSelEstAPCap || this.regSelEstAPInterior || this.regSelEstAMCap ||
          this.regSelEstAMInterior || this.regSelEstRRCap || this.regSelEstRRInterior ||
          this.regSelEstACCap || this.regSelEstACInterior || this.regSelEstDFCap ||
          this.regSelEstDFInterior || this.regSelEstGOCap || this.regSelEstGOInterior ||
          this.regSelEstTOCap || this.regSelEstTOInterior || this.regSelEstMTCap ||
          this.regSelEstMTInterior || this.regSelEstROCap || this.regSelEstROInterior ||
          this.regSelEstMSCap || this.regSelEstMSInterior || this.regSelEstPRCap ||
          this.regSelEstPRAreaMetr || this.regSelEstPRInterior || this.regSelEstSCCap ||
          this.regSelEstSCAreaMetr || this.regSelEstSCInterior || this.regSelEstRSCap ||
          this.regSelEstRSAreaMetr || this.regSelEstRSInterior){
        this.regSelBrasil = null
        this.regSelSudeste = null
        this.regSelSul = null
        this.regSelNorte = null
        this.regSelNordeste = null
        this.regSelCentrooeste = null
        this.visibleRegioes = false
      }

      if (!this.regSelEstSP){
        this.regSelEstSPCap = null
        this.regSelEstSPAreaMetr = null
        this.regSelEstSPLitoral = null
        this.regSelEstSPInterior = null
      }
      if (!this.regSelEstRJ){
        this.regSelEstRJCap = null
        this.regSelEstRJAreaMetr = null
        this.regSelEstRJInterior = null
      }
      if (!this.regSelEstES){
        this.regSelEstESCap = null
        this.regSelEstESInterior = null
      }
      if (!this.regSelEstMG){
        this.regSelEstMGCap = null
        this.regSelEstMGAreaMetr = null
        this.regSelEstMGInterior = null
      }
      if (!this.regSelEstBA){
        this.regSelEstBACap = null
        this.regSelEstBAAreaMetr = null
        this.regSelEstBAInterior = null
      }
      if (!this.regSelEstSE){
        this.regSelEstSECap = null
        this.regSelEstSEInterior = null
      }
      if (!this.regSelEstPE){
        this.regSelEstPECap = null
        this.regSelEstPEAreaMetr = null
        this.regSelEstPEInterior = null
      }
      if (!this.regSelEstAL){
        this.regSelEstALCap = null
        this.regSelEstALInterior = null
      }
      if (!this.regSelEstPB){
        this.regSelEstPBCap = null
        this.regSelEstPBInterior = null
      }
      if (!this.regSelEstRN){
        this.regSelEstRNCap = null
        this.regSelEstRNInterior = null
      }
      if (!this.regSelEstCE){
        this.regSelEstCECap = null
        this.regSelEstCEAreaMetr = null
        this.regSelEstCEInterior = null
      }
      if (!this.regSelEstPI){
        this.regSelEstPICap = null
        this.regSelEstPIInterior = null
      }
      if (!this.regSelEstMA){
        this.regSelEstMACap = null
        this.regSelEstMAInterior = null
      }
      if (!this.regSelEstPA){
        this.regSelEstPACap = null
        this.regSelEstPAAreaMetr = null
        this.regSelEstPAInterior = null
      }
      if (!this.regSelEstAP){
        this.regSelEstAPCap = null
        this.regSelEstAPInterior = null
      }
      if (!this.regSelEstAM){
        this.regSelEstAMCap = null
        this.regSelEstAMInterior = null
      }
      if (!this.regSelEstRR){
        this.regSelEstRRCap = null
        this.regSelEstRRInterior = null
      }
      if (!this.regSelEstAC){
        this.regSelEstACCap = null
        this.regSelEstACInterior = null
      }
      if (!this.regSelEstDF){
        this.regSelEstDFCap = null
        this.regSelEstDFInterior = null
      }
      if (!this.regSelEstGO){
        this.regSelEstGOCap = null
        this.regSelEstGOInterior = null
      }
      if (!this.regSelEstTO){
        this.regSelEstTOCap = null
        this.regSelEstTOInterior = null
      }
      if (!this.regSelEstMT){
        this.regSelEstMTCap = null
        this.regSelEstMTInterior = null
      }
      if (!this.regSelEstRO){
        this.regSelEstROCap = null
        this.regSelEstROInterior = null
      }
      if (!this.regSelEstMS){
        this.regSelEstMSCap = null
        this.regSelEstMSInterior = null
      }
      if (!this.regSelEstPR){
        this.regSelEstPRCap = null
        this.regSelEstPRAreaMetr = null
        this.regSelEstPRInterior = null
      }
      if (!this.regSelEstSC){
        this.regSelEstSCCap = null
        this.regSelEstSCAreaMetr = null
        this.regSelEstSCInterior = null
      }
      if (!this.regSelEstRS){
        this.regSelEstRSCap = null
        this.regSelEstRSAreaMetr = null
        this.regSelEstRSInterior = null
      }

      if (!this.regSelBrasil && !this.regSelSudeste && !this.regSelSul && !this.regSelNorte && !this.regSelNordeste && !this.regSelCentrooeste
          && !this.regSelEstSPCap && !this.regSelEstSPAreaMetr && !this.regSelEstSPLitoral && !this.regSelEstSPInterior
          && !this.regSelEstRJCap && !this.regSelEstRJAreaMetr && !this.regSelEstRJInterior && !this.regSelEstESCap && !this.regSelEstESInterior
          && !this.regSelEstMGCap && !this.regSelEstMGAreaMetr && !this.regSelEstMGInterior && !this.regSelEstBACap && !this.regSelEstBAAreaMetr && !this.regSelEstBAInterior
          && !this.regSelEstSECap && !this.regSelEstSEInterior && !this.regSelEstPECap && !this.regSelEstPEAreaMetr && !this.regSelEstPEInterior
          && !this.regSelEstALCap && !this.regSelEstALInterior && !this.regSelEstPBCap && !this.regSelEstPBInterior
          && !this.regSelEstRNCap && !this.regSelEstRNInterior && !this.regSelEstCECap && !this.regSelEstCEAreaMetr && !this.regSelEstCEInterior
          && !this.regSelEstPICap && !this.regSelEstPIInterior && !this.regSelEstMACap && !this.regSelEstMAInterior
          && !this.regSelEstPACap && !this.regSelEstPAAreaMetr && !this.regSelEstPAInterior
          && !this.regSelEstAPCap && !this.regSelEstAPInterior && !this.regSelEstAMCap && !this.regSelEstAMInterior
          && !this.regSelEstRRCap && !this.regSelEstRRInterior && !this.regSelEstACCap && !this.regSelEstACInterior
          && !this.regSelEstDFCap && !this.regSelEstDFInterior && !this.regSelEstGOCap && !this.regSelEstGOInterior
          && !this.regSelEstTOCap && !this.regSelEstTOInterior && !this.regSelEstMTCap && !this.regSelEstMTInterior
          && !this.regSelEstROCap && !this.regSelEstROInterior && !this.regSelEstMSCap && !this.regSelEstMSInterior
          && !this.regSelEstPRCap && !this.regSelEstPRAreaMetr && !this.regSelEstPRInterior && !this.regSelEstSCCap && !this.regSelEstSCAreaMetr && !this.regSelEstSCInterior
          && !this.regSelEstRSCap && !this.regSelEstRSAreaMetr && !this.regSelEstRSInterior
      ) {
        this.insereCepManual = true
      }

      if (this.regSelSudeste) {
        this.regiaoFaixasCeps.push({
          'id': 1,
          'cepini': '01000000',
          'cepfim': '39999999',
        })
      }
      if (this.regSelSul) {
        this.regiaoFaixasCeps.push({
          'id': 2,
          'cepini': '80000000',
          'cepfim': '99999999',
        })
      }
      if (this.regSelNordeste) {
        this.regiaoFaixasCeps.push({
          'id': 3,
          'cepini': '40000000',
          'cepfim': '65999999',
        })
      }
      if (this.regSelNorte) {
        this.regiaoFaixasCeps.push({
          'id': 4,
          'cepini': '66000000',
          'cepfim': '69999999',
        })
        this.regiaoFaixasCeps.push({
          'id': 5,
          'cepini': '76800000',
          'cepfim': '77999999',
        })
      }
      if (this.regSelCentrooeste) {
        this.regiaoFaixasCeps.push({
          'id': 6,
          'cepini': '70000000',
          'cepfim': '76799999',
        })
        this.regiaoFaixasCeps.push({
          'id': 7,
          'cepini': '78000000',
          'cepfim': '79999999',
        })
      }
      if (this.regSelEstSPCap) {
        this.regiaoFaixasCeps.push({
          'id': 8,
          'cepini': '01000000',
          'cepfim': '05999999',
        })
        this.regiaoFaixasCeps.push({
          'id': 9,
          'cepini': '08000000',
          'cepfim': '08499999',
        })
      }
      if (this.regSelEstSPAreaMetr) {
        this.regiaoFaixasCeps.push({
          'id': 10,
          'cepini': '06000000',
          'cepfim': '09999999',
        })
      }
      if (this.regSelEstSPLitoral) {
        this.regiaoFaixasCeps.push({
          'id': 11,
          'cepini': '11000000',
          'cepfim': '11999999',
        })
      }
      if (this.regSelEstSPInterior) {
        this.regiaoFaixasCeps.push({
          'id': 12,
          'cepini': '12000000',
          'cepfim': '19999999',
        })
      }
      if (this.regSelEstRJCap) {
        this.regiaoFaixasCeps.push({
          'id': 13,
          'cepini': '20000000',
          'cepfim': '23799999',
        })
      }
      if (this.regSelEstRJAreaMetr) {
        this.regiaoFaixasCeps.push({
          'id': 14,
          'cepini': '20000000',
          'cepfim': '26600999',
        })
      }
      if (this.regSelEstRJInterior) {
        this.regiaoFaixasCeps.push({
          'id': 15,
          'cepini': '26601000',
          'cepfim': '28999999',
        })
      }
      if (this.regSelEstESCap) {
        this.regiaoFaixasCeps.push({
          'id': 16,
          'cepini': '29000000',
          'cepfim': '29099999',
        })
      }
      if (this.regSelEstESInterior) {
        this.regiaoFaixasCeps.push({
          'id': 17,
          'cepini': '29100000',
          'cepfim': '29999-999',
        })
      }
      if (this.regSelEstMGCap) {
        this.regiaoFaixasCeps.push({
          'id': 18,
          'cepini': '30000000',
          'cepfim': '31999999',
        })
      }
      if (this.regSelEstMGAreaMetr) {
        this.regiaoFaixasCeps.push({
          'id': 19,
          'cepini': '30000000',
          'cepfim': '34999999',
        })
      }
      if (this.regSelEstMGInterior) {
        this.regiaoFaixasCeps.push({
          'id': 20,
          'cepini': '35000000',
          'cepfim': '39999999',
        })
      }
      if (this.regSelEstBACap) {
        this.regiaoFaixasCeps.push({
          'id': 21,
          'cepini': '40000000',
          'cepfim': '41999999',
        })
      }
      if (this.regSelEstBAAreaMetr) {
        this.regiaoFaixasCeps.push({
          'id': 22,
          'cepini': '40000000',
          'cepfim': '44470999',
        })
      }
      if (this.regSelEstBAInterior) {
        this.regiaoFaixasCeps.push({
          'id': 23,
          'cepini': '44471000',
          'cepfim': '48999999',
        })
      }
      if (this.regSelEstSECap) {
        this.regiaoFaixasCeps.push({
          'id': 24,
          'cepini': '49000000',
          'cepfim': '49099999',
        })
      }
      if (this.regSelEstSEInterior) {
        this.regiaoFaixasCeps.push({
          'id': 25,
          'cepini': '49100000',
          'cepfim': '49999999',
        })
      }

      if (this.regSelEstPECap) {
        this.regiaoFaixasCeps.push({
          'id': 26,
          'cepini': '50000000',
          'cepfim': '52999999',
        })
      }
      if (this.regSelEstPEAreaMetr) {
        this.regiaoFaixasCeps.push({
          'id': 27,
          'cepini': '50000000',
          'cepfim': '54999999',
        })
      }
      if (this.regSelEstPEInterior) {
        this.regiaoFaixasCeps.push({
          'id': 28,
          'cepini': '55000000',
          'cepfim': '56999999',
        })
      }
      if (this.regSelEstALCap) {
        this.regiaoFaixasCeps.push({
          'id': 29,
          'cepini': '58000000',
          'cepfim': '58099999',
        })
      }
      if (this.regSelEstALInterior) {
        this.regiaoFaixasCeps.push({
          'id': 30,
          'cepini': '58100000',
          'cepfim': '58999999',
        })
      }
      if (this.regSelEstPBCap) {
        this.regiaoFaixasCeps.push({
          'id': 31,
          'cepini': '58000000',
          'cepfim': '58099999',
        })
      }
      if (this.regSelEstPBInterior) {
        this.regiaoFaixasCeps.push({
          'id': 32,
          'cepini': '58100000',
          'cepfim': '58999999',
        })
      }
      if (this.regSelEstRNCap) {
        this.regiaoFaixasCeps.push({
          'id': 33,
          'cepini': '59000000',
          'cepfim': '59099999',
        })
      }
      if (this.regSelEstRNInterior) {
        this.regiaoFaixasCeps.push({
          'id': 33,
          'cepini': '59100000',
          'cepfim': '59999999',
        })
      }
      if (this.regSelEstCECap) {
        this.regiaoFaixasCeps.push({
          'id': 34,
          'cepini': '60000000',
          'cepfim': '60999999',
        })
      }
      if (this.regSelEstCEAreaMetr) {
        this.regiaoFaixasCeps.push({
          'id': 35,
          'cepini': '60000000',
          'cepfim': '61900999',
        })
      }
      if (this.regSelEstCEInterior) {
        this.regiaoFaixasCeps.push({
          'id': 36,
          'cepini': '61901000',
          'cepfim': '63999999',
        })
      }
      if (this.regSelEstPICap) {
        this.regiaoFaixasCeps.push({
          'id': 37,
          'cepini': '64000000',
          'cepfim': '64099999',
        })
      }
      if (this.regSelEstPIInterior) {
        this.regiaoFaixasCeps.push({
          'id': 38,
          'cepini': '64100000',
          'cepfim': '64999999',
        })
      }
      if (this.regSelEstMACap) {
        this.regiaoFaixasCeps.push({
          'id': 39,
          'cepini': '65000000',
          'cepfim': '65099999',
        })
      }
      if (this.regSelEstMAInterior) {
        this.regiaoFaixasCeps.push({
          'id': 40,
          'cepini': '65100000',
          'cepfim': '65999999',
        })
      }

      if (this.regSelEstPACap) {
        this.regiaoFaixasCeps.push({
          'id': 41,
          'cepini': '66000000',
          'cepfim': '66999999',
        })
      }
      if (this.regSelEstPAAreaMetr) {
        this.regiaoFaixasCeps.push({
          'id': 42,
          'cepini': '66000000',
          'cepfim': '67999999',
        })
      }
      if (this.regSelEstPAInterior) {
        this.regiaoFaixasCeps.push({
          'id': 43,
          'cepini': '68000000',
          'cepfim': '68899999',
        })
      }
      if (this.regSelEstAPCap) {
        this.regiaoFaixasCeps.push({
          'id': 44,
          'cepini': '68900000',
          'cepfim': '68914999',
        })
      }
      if (this.regSelEstAPInterior) {
        this.regiaoFaixasCeps.push({
          'id': 45,
          'cepini': '68915000',
          'cepfim': '68999999',
        })
      }
      if (this.regSelEstAMCap) {
        this.regiaoFaixasCeps.push({
          'id': 46,
          'cepini': '69000000',
          'cepfim': '69099999',
        })
      }
      if (this.regSelEstAMInterior) {
        this.regiaoFaixasCeps.push({
          'id': 47,
          'cepini': '69100000',
          'cepfim': '69299999',
        })
      }
      if (this.regSelEstRRCap) {
        this.regiaoFaixasCeps.push({
          'id': 48,
          'cepini': '69300000',
          'cepfim': '69339999',
        })
      }
      if (this.regSelEstRRInterior) {
        this.regiaoFaixasCeps.push({
          'id': 49,
          'cepini': '69340000',
          'cepfim': '69389999',
        })
      }
      if (this.regSelEstACCap) {
        this.regiaoFaixasCeps.push({
          'id': 50,
          'cepini': '69900000',
          'cepfim': '69920999',
        })
      }
      if (this.regSelEstACInterior) {
        this.regiaoFaixasCeps.push({
          'id': 51,
          'cepini': '69921000',
          'cepfim': '69999999',
        })
      }
      if (this.regSelEstDFCap) {
        this.regiaoFaixasCeps.push({
          'id': 52,
          'cepini': '70000000',
          'cepfim': '70999999',
        })
      }
      if (this.regSelEstDFInterior) {
        this.regiaoFaixasCeps.push({
          'id': 53,
          'cepini': '71000000',
          'cepfim': '73699999',
        })
      }
      if (this.regSelEstGOCap) {
        this.regiaoFaixasCeps.push({
          'id': 54,
          'cepini': '72800000',
          'cepfim': '73999999',
        })
        this.regiaoFaixasCeps.push({
          'id': 55,
          'cepini': '74000000',
          'cepfim': '74894999',
        })
      }
      if (this.regSelEstGOInterior) {
        this.regiaoFaixasCeps.push({
          'id': 56,
          'cepini': '74895000',
          'cepfim': '76799999',
        })
      }
      if (this.regSelEstTOCap) {
        this.regiaoFaixasCeps.push({
          'id': 57,
          'cepini': '77000000',
          'cepfim': '77270999',
        })
      }
      if (this.regSelEstTOInterior) {
        this.regiaoFaixasCeps.push({
          'id': 58,
          'cepini': '77300000',
          'cepfim': '77995999',
        })
      }
      if (this.regSelEstMTCap) {
        this.regiaoFaixasCeps.push({
          'id': 59,
          'cepini': '78000000',
          'cepfim': '78109999',
        })
      }
      if (this.regSelEstMTInterior) {
        this.regiaoFaixasCeps.push({
          'id': 60,
          'cepini': '78110000',
          'cepfim': '78899999',
        })
      }
      if (this.regSelEstROCap) {
        this.regiaoFaixasCeps.push({
          'id': 61,
          'cepini': '78900000',
          'cepfim': '78930999',
        })
      }
      if (this.regSelEstROInterior) {
        this.regiaoFaixasCeps.push({
          'id': 62,
          'cepini': '78931000',
          'cepfim': '78999999',
        })
      }
      if (this.regSelEstMSCap) {
        this.regiaoFaixasCeps.push({
          'id': 63,
          'cepini': '79000000',
          'cepfim': '79129999',
        })
      }
      if (this.regSelEstMSInterior) {
        this.regiaoFaixasCeps.push({
          'id': 64,
          'cepini': '79130000',
          'cepfim': '79999999',
        })
      }
      if (this.regSelEstPRCap) {
        this.regiaoFaixasCeps.push({
          'id': 65,
          'cepini': '80000000',
          'cepfim': '82999999',
        })
      }
      if (this.regSelEstPRAreaMetr) {
        this.regiaoFaixasCeps.push({
          'id': 66,
          'cepini': '80000000',
          'cepfim': '83800999',
        })
      }
      if (this.regSelEstPRInterior) {
        this.regiaoFaixasCeps.push({
          'id': 67,
          'cepini': '83801000',
          'cepfim': '87999999',
        })
      }


      if (this.regSelEstSCCap) {
        this.regiaoFaixasCeps.push({
          'id': 66,
          'cepini': '88000000',
          'cepfim': '82999999',
        })
      }
      if (this.regSelEstSCAreaMetr) {
        this.regiaoFaixasCeps.push({
          'id': 67,
          'cepini': '88000000',
          'cepfim': '88469999',
        })
      }
      if (this.regSelEstSCInterior) {
        this.regiaoFaixasCeps.push({
          'id': 68,
          'cepini': '88470000',
          'cepfim': '89999999',
        })
      }
      if (this.regSelEstRSCap) {
        this.regiaoFaixasCeps.push({
          'id': 69,
          'cepini': '90000000',
          'cepfim': '91999999',
        })
      }
      if (this.regSelEstRSAreaMetr) {
        this.regiaoFaixasCeps.push({
          'id': 70,
          'cepini': '90000000',
          'cepfim': '94900999',
        })
      }
      if (this.regSelEstRSInterior) {
        this.regiaoFaixasCeps.push({
          'id': 71,
          'cepini': '94901000',
          'cepfim': '99999999',
        })
      }


    },


    adicionaFaixaCep(){
      console.log('adicionaFaixaCep')


    },


    confRegraDesc(){
      console.log('confRegraDesc')
      console.log(this.baseRegraData.nome)
      this.submittedBaseRegra = true

      if (this.baseRegraData.nome
          && this.baseRegraData.regra
          && (this.baseRegraData.cepini && this.baseRegraData.cepfim) || this.regiaoFaixasCeps.length > 0){
        this.baseRegraData.fretecotabasetab_id = this.freteCotaBaseTabData.id
        this.baseRegraData.empresa_id = this.freteCotaBaseTabData.empresa_id
        if (this.regiaoFaixasCeps.length > 0) {
          this.baseRegraData. fxceps = this.regiaoFaixasCeps
        }
        this.showModalBaseRegra = false

        console.log('regiaoFaixasCeps')
        console.log(this.regiaoFaixasCeps)

        if (!Array.isArray(this.freteCotaBaseTabData.regras)) {
          this.freteCotaBaseTabData.regras = [];
        }
        if (this.baseRegraData.cepini && this.baseRegraData.cepfim) {
          this.regiaoFaixasCeps.push({
            'cepini': this.baseRegraData.cepini,
            'cepfim': this.baseRegraData.cepfim
          })
        }
        this.regiaoFaixasCeps.forEach((faixa) => {
          console.log('faixa')
          console.log(faixa.cepini)

          const jaExiste = this.freteCotaBaseTabData.regras.some(
              item => item.cepini === faixa.cepini
          )
          console.log('jaExiste')
          console.log(jaExiste)
          if (!jaExiste || jaExiste === false) {
            console.log('vaic_criar')
            this.baseRegraData.cepini = faixa.cepini
            this.baseRegraData.cepfim = faixa.cepfim
            this.freteCotaBaseTabData.regras.push({ ...this.baseRegraData })
          }
          // console.log('this.freteCotaBaseTabData.regras')
          // console.log(this.freteCotaBaseTabData.regras)
        })

      }
    },


    confImpPlan(){
      console.log('confImpPlan')
      this.submittedImpPlan = true
      if (this.dropzoneFile.name){
        this.showModalImpPlan = false
        this.updating = true

        let arquivo = document.querySelector(".dropzoneFile").files[0]
        console.log(arquivo)
        let formData = new FormData()
        formData.append("iddata", this.idData)
        formData.append("descranexo", this.descranexo)
        formData.append("filename", arquivo.name)
        formData.append("file", arquivo)

        api.post(`${getBaseUrl()}api/freteimporplantde`,formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          // this.mediasData = res.data[0]
          this.updating = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações importadas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          }).then(res => {
            console.log(res)
            this.carregarDados()
          })

        }).catch((err) => {

          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
        })
      }
    },


    selectedFile(){
      console.log('selectedFile')
      this.dropzoneFile = document.querySelector(".dropzoneFile").files[0]
    },

    importBaseTDE(){
      console.log('importBaseTDE')
      console.log('novaImpPlan')
      this.submittedImpPlan = false
      this.showModalImpPlan = true

    },


    novaBaseDest(){
      console.log('novaBaseDest')
      const routeData = this.$router.resolve(`/cotacaofretesbaseelk/editar/0?idtabela=${this.freteCotaBaseTabData._idtabela}`)
      window.open(routeData.href, '_blank')
    },

    novaBaseTDE(){
      console.log('novaBaseTde')
      this.baseTdeData = {}
      this.submittedBaseTde = false
      this.showModalBaseTde = true
    },

    novaRegraDesc(){
      console.log('novaRegraDesc')

      this.regSelBrasil = null
      this.regSelSudeste = null
      this.regSelSul = null
      this.regSelNorte = null
      this.regSelNordeste = null
      this.regSelCentrooeste = null
      this.regSelEstSPCap = null
      this.regSelEstSPAreaMetr = null
      this.regSelEstSPLitoral = null
      this.regSelEstSPInterior = null
      this.regSelEstRJCap = null
      this.regSelEstRJAreaMetr = null
      this.regSelEstRJInterior = null
      this.regSelEstESCap = null
      this.regSelEstESInterior = null
      this.regSelEstMGCap = null
      this.regSelEstMGAreaMetr = null
      this.regSelEstMGInterior = null
      this.regSelEstBACap = null
      this.regSelEstBAAreaMetr = null
      this.regSelEstBAInterior = null
      this.regSelEstSECap = null
      this.regSelEstSEInterior = null
      this.regSelEstPECap = null
      this.regSelEstPEAreaMetr = null
      this.regSelEstPEInterior = null
      this.regSelEstALCap = null
      this.regSelEstALInterior = null
      this.regSelEstPBCap = null
      this.regSelEstPBInterior = null
      this.regSelEstRNCap = null
      this.regSelEstRNInterior = null
      this.regSelEstCECap = null
      this.regSelEstCEAreaMetr = null
      this.regSelEstCEInterior = null
      this.regSelEstPICap = null
      this.regSelEstPIInterior = null
      this.regSelEstMACap = null
      this.regSelEstMAInterior = null
      this.regSelEstPACap = null
      this.regSelEstPAAreaMetr = null
      this.regSelEstPAInterior = null
      this.regSelEstAPCap = null
      this.regSelEstAPInterior = null
      this.regSelEstAMCap = null
      this.regSelEstAMInterior = null
      this.regSelEstRRCap = null
      this.regSelEstRRInterior = null
      this.regSelEstACCap = null
      this.regSelEstACInterior = null
      this.regSelEstDFCap = null
      this.regSelEstDFInterior = null
      this.regSelEstGOCap = null
      this.regSelEstGOInterior = null
      this.regSelEstTOCap = null
      this.regSelEstTOInterior = null
      this.regSelEstMTCap = null
      this.regSelEstMTInterior = null
      this.regSelEstROCap = null
      this.regSelEstROInterior = null
      this.regSelEstMSCap = null
      this.regSelEstMSInterior = null
      this.regSelEstPRCap = null
      this.regSelEstPRAreaMetr = null
      this.regSelEstPRInterior = null
      this.regSelEstSCCap = null
      this.regSelEstSCAreaMetr = null
      this.regSelEstSCInterior = null
      this.regSelEstRSCap = null
      this.regSelEstRSAreaMetr = null
      this.regSelEstRSInterior = null

      this.submittedBaseRegra = false
      this.baseRegraData = {}
      this.regiaoFaixasCeps = []
      this.showModalBaseRegra = true


    },


    excluirEmpr(cnpjEmpr){
      console.log('excluirEmpr')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Associação de Empresa",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/fretecotabaseemprelk`, {
            params: {
              'cnpj': cnpjEmpr,
              'empresasData': this.freteCotaBaseEmprsData,
              'idTabela': this.freteCotaBaseTabData._idtabela
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.carregarDados()
          })
        }
      })
    },


    exclBaseOrigem(idData){
      console.log('exclBaseOrigem')
      this.showModalBaseOrigem = false
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Base de Origem",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/fretecotabaseorigem`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.carregarDados()
          })
        }
      })
    },


    exclTxPeso(pesoini){
      console.log('exclTxPeso')
      console.log(pesoini)
      this.txPesoData.txpesos = this.txPesoData.txpesos.filter(
          taxa => taxa.pesoini !== pesoini
      );
    },


    exclTxPesoFxPeso(idData){
      console.log('exclTxPeso')
      console.log(idData)
      this.showModalTxPeso = false
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Taxa Peso",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        console.log('result')
        console.log(result)
        // if (result.value) {
        //   this.updating = true
        //   api.delete(`${getBaseUrl()}api/fretecotabaseorigem`, {
        //     params: {
        //       'iddata': idData
        //     }
        //   }).then((res) => {
        //     console.log('then axios delete')
        //     console.log(res.data)
        //     this.carregarDados()
        //   })
        // }
      })
    },


    exclRegraDesc(idData){
      console.log('exclRegraDesc')
      this.showModalBaseRegra = false
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Regra de Desconto",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/deleteregrafrete`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.carregarDados()
          })
        }
      })
    },


    confEmpresa(){
      console.log('confEmpresa')
      console.log(this.idData)
      this.submittedEmprData = true
      if (this.freteCotaBaseEmprData.empresa_id) {
        this.updating = true
        this.showModalEmpresa = false
        //this.freteCotaBaseEmprData.fretecotabasetab_id = this.freteCotaBaseTabData.id
        api.post(`${getBaseUrl()}api/fretecotabaseemprelk`, {
          freteCotaBaseEmpr: this.freteCotaBaseEmprData,
          empresasData: this.freteCotaBaseEmprsData,
          idTabela: this.freteCotaBaseTabData._idtabela
        }).then((res) => {
          console.log('res post baseempr')
          console.log(res)
          this.carregarDados()
        })
      }
    },


    novaEmpresa(){
      console.log('novaEmpresa')
      this.freteCotaBaseEmprData = {}
      this.submittedEmprData = false
      this.showModalEmpresa = true
    },


    pesqEmpresa(evt){
      console.log('pesqEmpresa')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/emprepesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqEmpresa = res.data
        })
      }
    },

    novaTaxaAdic(){
      console.log('novaTaxaAdic')
      this.taxaAdicData = {}
      this.submittedTaxaAdic = false
      this.showModalTaxaAdic = true
    },


    novaTxCep(){
      console.log('novaTxCep')
      this.cepPesoData = {}
      this.submittedCepPeso = false
      this.showModalCepPeso = true
    },

    novaTxPeso(){
      console.log('novaTxPeso')
      this.txPesoData = {}
      this.submittedTxPeso = false
      this.showModalTxPeso = true
    },

    pesqSegto(evt) {
      console.log('pesqSegto')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1) {
        // this.loadingTransp = true
        api.get(`${getBaseUrl()}api/segtopesq`, {
          params: { q: query, e: this.freteCotaBaseTabData.empresa }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqSegto = res.data
        })
      }
    },


    excluirBaseTab() {
      console.log('excluirBaseTab')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Base de Cotação",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/fretecotabasetabelk`, {
            params: {
              '_idtabela': this.freteCotaBaseTabData._idtabela
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.$router.push('/cotacaofretesbaseelk/list')
            })
          })
        }
      })
    },


    confBaseTrt() {
      console.log('confBaseTrt')
      this.submittedBaseTrt = true
      if (this.baseTrtData.destino && this.baseTrtData.estado && this.baseTrtData.cepini && this.baseTrtData.cepfim) {
        this.showModalBaseTrt = false
        this.updating = true
        this.baseTrtData._idtabela = this.freteCotaBaseTabData._idtabela
        api.post(`${getBaseUrl()}api/fretecotabasetrtelk`, {
          freteCotaBaseTrt: this.baseTrtData
        }).then((res) => {
          console.log('res post ocorfinal')
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informação salva com sucesso",
            showConfirmButton: false,
            timer: 1500
          }).then(
              this.carregarDados
          )
        })
      }
    },

    confBaseTda() {
      console.log('confBaseTda')
      this.submittedBaseTda = true
      if (this.baseTdaData.destino && this.baseTdaData.estado && this.baseTdaData.cepini && this.baseTdaData.cepfim) {
        this.showModalBaseTda = false
        this.updating = true
        this.baseTdaData._idtabela = this.freteCotaBaseTabData._idtabela
        api.post(`${getBaseUrl()}api/fretecotabasetdaelk`, {
          freteCotaBaseTda: this.baseTdaData
        }).then((res) => {
          console.log('res post ocorfinal')
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informação salva com sucesso",
            showConfirmButton: false,
            timer: 1500
          }).then(
              this.carregarDados
          )
        })
      }
    },

    confBaseTde() {
      console.log('confBaseTde')
      this.submittedBaseTde = true
      if (this.baseTdeData.cnpj && this.baseTdeData.nome) {
        this.showModalBaseTde = false
        this.updating = true
        this.baseTdeData._idtabela = this.freteCotaBaseTabData._idtabela
        api.post(`${getBaseUrl()}api/fretecotabasetdeelk`, {
          freteCotaBaseTde: this.baseTdeData
        }).then((res) => {
          console.log('res post ocorfinal')
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informação salva com sucesso",
            showConfirmButton: false,
            timer: 1500
          }).then(
              this.carregarDados
          )
        })
      }
    },

    confTaxaAdic() {
      console.log('confTaxaAdic')
      this.submittedTaxaAdic = true
      if (this.taxaAdicData.descricao && this.taxaAdicData.destcnpj && this.taxaAdicData.destnome) {
        this.showModalTaxaAdic = false
        this.taxaAdicData.fretecotabasetab_id = this.freteCotaBaseTabData.id
        api.post(`${getBaseUrl()}api/fretecotabaseadicelk`, {
          freteCotaBaseAdic: this.taxaAdicData
        }).then((res) => {
          console.log('res post ocorfinal')
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informação salva com sucesso",
            showConfirmButton: false,
            timer: 1500
          }).then(
              this.carregarDados
          )
        })
      }

    },



    confCepPeso() {
      console.log('confCepPeso')
      this.submittedCepPeso = true
      if (this.cepPesoData.destino && this.cepPesoData.cepini && this.cepPesoData.cepfim) {
        this.updating = true
        this.showModalCepPeso = false
        this.cepPesoData._idtabela =  this.freteCotaBaseTabData._idtabela
        api.post(`${getBaseUrl()}api/fretecotabaseceppesoelk`, {
          freteCotaCepPeso: this.cepPesoData
        }).then((res) => {
          console.log('res post ocorfinal')
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informação salva com sucesso",
            showConfirmButton: false,
            timer: 1500
          }).then(
              this.carregarDados
          )
        })
      }

    },

    onRowDblClickBase(row) {
      console.log('onRowDblClickBase')
      console.log(row.data)
      this.$router.push(`/cotacaofretesbase/editar/${row.data.id}`)
    },

    onRowDblClickTrt(row) {
      console.log('onRowDblClickTrt')
      console.log(row.data)
      this.baseTrtData = row.data
      this.showModalBaseTrt = true
    },

    onRowDblClickTda(row) {
      console.log('onRowDblClickTda')
      console.log(row.data)
      this.baseTdaData = row.data
      this.showModalBaseTda = true
    },

    onRowDblClickTde(row) {
      console.log('onRowDblClickTde')
      console.log(row.data)
      const routeData = this.$router.resolve(`/cotacaofretesbasetde/editar/${row.data.id}`)
      window.open(routeData.href, '_blank')
    },

    onRowDblClickAdic(row) {
      console.log('onRowDblClickAdic')
      console.log(row.data)
      this.taxaAdicData = row.data
      this.showModalTaxaAdic = true
    },

    onRowDblClickRegra(row) {
      console.log('onRowDblClickRegra')
      console.log(row.data)
      this.baseRegraData = row.data
      this.showModalBaseRegra = true
    },


    carregarDados() {
      console.log('carregarDados_bases_elk')
      console.log(this.idData)
      this.updating = true
      api.get(`${getBaseUrl()}api/fretecotabaseelk`, {
        params: { iddata: this.idData }
      }).then((res) => {
        console.log('then axios cotaFreteBase')
        console.log(res.data)
        this.freteCotaBaseTabData = res.data[0]
        this.seguimentoData = res.data[1]
        this.freteCotaBaseEmprsData = res.data[2]

        if (this.seguimentoData && this.seguimentoData.id) {
          this.dtListPesqSegto = [
            {
              'codigo': this.seguimentoData.codigo,
              'nome': this.seguimentoData.nome,
            }
          ]
        }

        this.idData = this.freteCotaBaseTabData._id
        this.title = `Editar Tabela Base de Cotação ELK (${this.freteCotaBaseTabData._id}) ${this.freteCotaBaseTabData.descricao}`


        const paramsReq = {
          'idTabela': this.freteCotaBaseTabData._idtabela,
          'page': 1,
          'pageSize': 20,
        }
        api.get(`${getBaseUrl()}api/fretecotabasetabbaseselk`, {
          params: paramsReq
        }).then(response => {
          console.log('response.bases')
          // console.log(response.data)
          this.freteCotaBasesData = {
            result: response.data[0],
            count: response.data[1],
          }
          this.pageSetsBases.totalRecordsCount = response.data[1]
          this.pageSetsBases.currentPage = 1
          this.pageSetsBases.pageSize = 20
        })

        api.get(`${getBaseUrl()}api/fretecotabasetabtrtselk`, {
          params: paramsReq
        }).then(response => {
          console.log('response.trts')
          // console.log(response.data)
          this.freteCotaTrtsData = {
            result: response.data[0],
            count: response.data[1],
          }
          this.pageSetsTrts.totalRecordsCount = response.data[1]
          this.pageSetsTrts.currentPage = 1
          this.pageSetsTrts.pageSize = 20
        })

        api.get(`${getBaseUrl()}api/fretecotabasetabtdaselk`, {
          params: paramsReq
        }).then(response => {
          console.log('response.tdas')
          // console.log(response.data)
          this.freteCotaTdasData = {
            result: response.data[0],
            count: response.data[1],
          }
          this.pageSetsTdas.totalRecordsCount = response.data[1]
          this.pageSetsTdas.currentPage = 1
          this.pageSetsTdas.pageSize = 20
        })

        api.get(`${getBaseUrl()}api/fretecotabasetabtdeselk`, {
          params: paramsReq
        }).then(response => {
          console.log('response.tdes')
          // console.log(response.data)
          this.freteCotaTdesData = {
            result: response.data[0],
            count: response.data[1],
          }
          this.pageSetsTdes.totalRecordsCount = response.data[1]
          this.pageSetsTdes.currentPage = 1
          this.pageSetsTdes.pageSize = 20
        })

        api.get(`${getBaseUrl()}api/fretecotabasetabadicselk`, {
          params: paramsReq
        }).then(response => {
          console.log('response.adics')
          console.log(response.data)
          this.freteCotaAdicsData = {
            result: response.data[0],
            count: response.data[1],
          }
          this.pageSetsAdics.totalRecordsCount = response.data[1]
          this.pageSetsAdics.currentPage = 1
          this.pageSetsAdics.pageSize = 20
        })

        api.get(`${getBaseUrl()}api/fretecotabasecepesoselk`, {
          params: paramsReq
        }).then(response => {
          console.log('response.cepPesos')
          console.log(response.data)
          this.freteCotaCepPesosData = {
            result: response.data[0],
            count: response.data[1],
          }
          this.pageSetsCepsPesos.totalRecordsCount = response.data[1]
          this.pageSetsCepsPesos.currentPage = 1
          this.pageSetsCepsPesos.pageSize = 20
        })

        this.updating = false



      })
    },


    formSubmit() {
      console.log('formSubmit')
      console.log(this.freteCotaBaseTabData.expira)
      this.submitted = true;
      if (this.freteCotaBaseTabData.descricao && this.freteCotaBaseTabData.transpnome) {
        this.updating = true
        this.errosValid = []
        api.post(`${getBaseUrl()}api/fretecotabasetabelk`, {
          freteCotaBaseTabData: this.freteCotaBaseTabData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.updating = false
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          if (this.idData === 0) {
            this.idData = res.data[0].id
            this.freteCotaBaseTabData = res.data[0]
            this.$router.replace('/cotacaofretesbasetab/editar/' + this.idData)
          }
        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
          this.activeTab = 0
        })
      }
    },



    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 0 });
      }
      return 0.00;
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2 });
      }
      return "0,00";
    },

  },

  mounted() {
    console.log('mounted_user_editar_0')
    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra) {
      this.idData = rota.substring(ultimaBarra + 1)
    }
    console.log(`idData: ${this.idData}`)
    if (this.idData && this.idData !== '') {
      this.carregarDados()
    } else {
      this.title = `Criando Nova Tabela Base Cotação de Frete ELK`
      this.updating = false
    }
  },


};

</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" :status="freteCotaBaseTabData.status" />

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`" show dismissible variant="danger">
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <div class="checkout-tabs" v-if="!updating">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">


              <b-button variant="outline-success" class="mx-2" @click="formSubmit">
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar
              </b-button>

              <b-button variant="outline-danger" class="mx-2" @click="excluirBaseTab">
                <i class="bx bx-trash font-size-16 align-middle me-2"></i>
                Excluir
              </b-button>

              <b-dropdown class="btn-group mx-2" variant="outline-info">
                <template v-slot:button-content>
                  <i class="fa fa-plus me-2"></i>
                  Criar
                  <i class="mdi mdi-chevron-down ms-4"></i>
                </template>

                <a class="dropdown-item" href="javascript: void(0);" @click="novaEmpresa">Nova Empresa</a>
                <a class="dropdown-item" href="javascript: void(0);" @click="novaBaseDest">Nova Base Destinatário</a>
                <a class="dropdown-item" href="javascript: void(0);" @click="novaBaseTrt">Novo Destino TRT</a>
                <a class="dropdown-item" href="javascript: void(0);" @click="novaBaseTda">Novo Destino TDA</a>
                <a class="dropdown-item" href="javascript: void(0);" @click="novaBaseTDE">Novo Base TDE</a>
                <a class="dropdown-item" href="javascript: void(0);" @click="novaOrigem">Nova Origem</a>
                <a class="dropdown-item" href="javascript: void(0);" @click="novaRegraDesc">Nova Regra de Desconto</a>
                <a class="dropdown-item" href="javascript: void(0);" @click="novaTxCep">Nova Taxa Cep</a>
                <a class="dropdown-item" href="javascript: void(0);" @click="novaTxPeso">Nova Taxa Peso</a>
              </b-dropdown>


              <b-dropdown class="btn-group mx-2" variant="outline-warning">
                <template v-slot:button-content>
                  <i class="fa fa-edit me-2"></i>
                  Alteração
                  <i class="mdi mdi-chevron-down ms-4"></i>
                </template>

                <a class="dropdown-item" href="javascript: void(0);" @click="altGlobalTrt">Alteração Global TRT</a>
                <a class="dropdown-item" href="javascript: void(0);" @click="altGlobalTde">Alteração Global TDE</a>

              </b-dropdown>

              <b-button variant="outline-info" class="mx-2" @click="importBaseTDE" :disabled="true">
                <i class="bx bx-upload font-size-16 align-middle me-2"></i>
                Importar Base TDE
              </b-button>

              <b-button variant="outline-success" class="mx-2" @click="exportarVtex">
                <i class="bx bx-download font-size-16 align-middle me-2"></i>
                Exportar Vtex
              </b-button>

            </div>
          </div>
        </div>
      </div>


      <form class="needs-validation" @submit.prevent="formSubmit">


        <div class="card">
          <div class="card-body">

            <b-card-header header-tag="header" role="tab">
              <h6 class="m-0">
                <a v-b-toggle.accordion-8 class="text-dark" href="javascript: void(0);">Tabela (Cabeçalho)</a>
              </h6>
            </b-card-header>
            <b-collapse id="accordion-8" visible accordion="my-accordion-8" role="tabpanel">
              <b-card-body>

                <div class="row mb-2">

                  <div class="col-md-4">
                    <label for="descricao">Descrição</label>
                    <div class="position-relative">
                      <input id="descricao" type="text" v-model="freteCotaBaseTabData.descricao" class="form-control"
                             :class="{ 'is-invalid': submitted && !freteCotaBaseTabData.descricao }" placeholder="Descrição" />
                      <div v-if="submitted && !freteCotaBaseTabData.descricao" class="invalid-feedback">
                        <span>Campo Descrição obrigatório, favor preencher.</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <label for="transpnome">Transportadora</label>
                    <div class="position-relative">
                      <input id="transpnome" type="text" v-model="freteCotaBaseTabData.transpnome" class="form-control"
                             :class="{ 'is-invalid': submitted && !freteCotaBaseTabData.descricao }"
                             placeholder="Transportadora" />
                      <div v-if="submitted && !freteCotaBaseTabData.descricao" class="invalid-feedback">
                        <span>Campo Transportadora obrigatório, favor preencher.</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="transpcnpj">CNPJ Transportadora</label>
                    <div class="position-relative">
                      <input id="transpcnpj" type="text" v-model="freteCotaBaseTabData.transpcnpj" class="form-control"
                             :class="{ 'is-invalid': submitted && !freteCotaBaseTabData.transpcnpj }"
                             placeholder="CNPJ Transportadora" />
                      <div v-if="submitted && !freteCotaBaseTabData.transpcnpj" class="invalid-feedback">
                        <span>Campo CNPJ Transportadora obrigatório, favor preencher.</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <div class="mb-3">
                      <label for="statuscont">Status</label>
                      <select id="statuscont" v-model="freteCotaBaseTabData.status" class="form-control">
                        <option value="A">Ativo</option>
                        <option value="I">Inativo</option>
                        <option value="EX">Expirado</option>
                      </select>
                    </div>
                  </div>

                </div>


                <div class="row mb-4">

                  <div class="col-md-4">
                    <label for="cidade">Seguimento</label>
                    <multiselect @search-change="pesqSegto"
                                 v-model="freteCotaBaseTabData.segto" placeholder="Pesquisar seguimento" :options="dtListPesqSegto"
                                 :searchable="true" label="nome" track-by="nome"
                                 value-prop="codigo">
                      <template #option="slotProps">
                        <div class="row">
                          <div>
                              <span class="text-info">
                                {{ slotProps.option.codigo }}
                              </span>

                          </div>
                          <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                        </div>
                      </template>
                    </multiselect>

                  </div>


                  <div class="col-md-2">
                    <label for="cubisenmt">Isenção Cubagem até M³</label>
                    <div class="position-relative">
                      <input id="cubisenmt" type="number" v-model="freteCotaBaseTabData.cubisenmt"
                             class="form-control text-end" placeholder="Isenção Cubagem até M³" />
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="cubisenkg">Isenção Cubagem até Kg</label>
                    <div class="position-relative">
                      <input id="cubisenkg" type="number" v-model="freteCotaBaseTabData.cubisenkg"
                             class="form-control text-end" placeholder="Isenção Cubagem até Kg" />
                    </div>
                  </div>

                  <div class="col-md-2">
                    <label for="dmaisum">D + Dias</label>
                    <div class="position-relative">
                      <input id="dmaisum" type="number" v-model="freteCotaBaseTabData.dmaisum"
                             class="form-control text-end" placeholder="D + Dias" />
                    </div>
                  </div>



                  <div class="col-md-2">
                    <label for="ftcub">Fator de Cubagem (Geral)</label>
                    <div class="position-relative">
                      <input id="ftcub" type="number" v-model="freteCotaBaseTabData.cubft" class="form-control text-end"
                             placeholder="Fator de Cubagem" />
                    </div>
                  </div>


                </div>


                <div class="row mb-2">





                </div>


                <div class="row mb-2">

                  <div class="col-md-2">
                    <div class="mb-3">
                      <label for="expíra">Dias Expirar Sem Contratação</label>
                      <input
                          id="expíra"
                          v-model="freteCotaBaseTabData.expira"
                          type="number"
                          class="form-control"
                          placeholder="Dias Expirar Sem Contratação" />
                    </div>
                  </div>

                  <div class="col-md-2">
                    <div class="mb-3">
                      <label for="ultcontr">Última Contratação</label>
                      <input
                          id="ultcontr"
                          v-model="freteCotaBaseTabData.ultcontr"
                          type="date"
                          class="form-control"
                          :disabled="true"
                          placeholder="Última Contratação" />
                    </div>
                  </div>

                  <div class="col-sm-4">
                    <div class="mb-3">
                      <label for="tagtransp">Tag Transportadora</label>
                      <select id="tagtransp" v-model="freteCotaBaseTabData.tagtransp" class="form-control">
                        <option value="ALFA">Alfa</option>
                        <option value="ATIVA">Ativa</option>
                        <option value="BERTO">Bertolini</option>
                        <option value="BRP">Braspress</option>
                        <option value="PATR">Patrus</option>
                        <option value="QLTY">Quality</option>
                        <option value="SOL">Solística</option>
                        <option value="SSW">SSW</option>
                        <option value="TRV">Translovato</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <div class="mb-3">
                      <label for="@timestamp">Criação</label>
                      <input
                          id="@timestamp"
                          v-model="freteCotaBaseTabData.created_at"
                          type="datetime-local"
                          class="form-control"
                          :disabled="true"
                          placeholder="Criação" />
                    </div>
                  </div>

                </div>

              </b-card-body>

            </b-collapse>
          </div>
        </div>

      </form>



      <div class="card">
        <div class="card-body">
          <b-card-header header-tag="header" role="tab">
            <h6 class="m-0">
              <a v-b-toggle.accordion-10 class="text-dark" href="javascript: void(0);">Empresas</a>
            </h6>
          </b-card-header>
          <b-collapse id="accordion-10" visible accordion="my-accordion-10" role="tabpanel">
            <b-card-body>

              <div class="table-responsive mb-0">
                <table class="table align-middle table-nowrap">
                  <thead class="table-light">
                  <tr>

                    <th class="align-middle">ID</th>
                    <th class="align-middle">Código</th>
                    <th class="align-middle">Nome</th>
                    <th class="align-middle">Fantasia</th>
                    <th class="align-middle">CNPJ</th>
                    <th class="align-middle">Criação</th>
                    <th class="align-middle">Ações</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="data in freteCotaBaseEmprsData" :key="data.id">

                    <td>{{ data.id }} </td>
                    <td>{{ data.codigo }} </td>
                    <td class="text-wrap">{{ data.nome }} </td>
                    <td>{{ data.fantasia }} </td>
                    <td> {{ data.cnpj }} </td>
                    <td>{{ formatDateTime(data.created_at) }} </td>
                    <td>
                      <div class="button-items">
                        <b-button variant="outline-danger" @click="excluirEmpr(data.cnpj)">
                          <i class="mdi mdi-trash-can d-block font-size-16"></i>
                        </b-button>
                      </div>
                    </td>

                  </tr>
                  </tbody>
                </table>


              </div>


            </b-card-body>
          </b-collapse>
        </div>
      </div>




      <div class="card">
        <div class="card-body">
          <b-card-header header-tag="header" role="tab">
            <h6 class="m-0">
              <a v-b-toggle.accordion-5 class="text-dark" href="javascript: void(0);">Bases de Destinatários</a>
            </h6>
          </b-card-header>
          <b-collapse id="accordion-5" visible accordion="my-accordion-5" role="tabpanel">
            <b-card-body>

              <div v-if="!updating">
                <ejs-grid :dataSource="freteCotaBasesData"
                          ref="dataGridBases"
                          :actionBegin="changePageBases"
                          :allowFiltering="false"
                          :allowPdfExport="true"
                          :allowExcelExport="true"
                          :allowPaging="true"
                          :enableColumnVirtualization="true"
                          :recordDoubleClick="recDblClickBase"
                          :dataBound="dataBoundBases"
                          :pageSettings="pageSetsBases"
                          :toolbar="toolbar"
                          :selectionSettings="{ mode: 'Row', type: 'Multiple' }"
                          :scrollSettings="{enableColumnScrolling: true, enableRowScrolling: true}">
                  <e-columns>
                    <e-column field="_id" headerText="ID" textAlign="Left"></e-column>
                    <e-column field="_idtabela" headerText="ID Tabela" textAlign="Right"></e-column>
                    <e-column field="cepini" headerText="CEP Início" textAlign="Right"></e-column>
                    <e-column field="cepfim" headerText="CEP Fim" textAlign="Right"></e-column>
                    <e-column field="cidadefim" headerText="Cidade Fim" textAlign="Right"></e-column>
                  </e-columns>

                </ejs-grid>
              </div>

            </b-card-body>
          </b-collapse>
        </div>
      </div>


      <div class="card">
        <div class="card-body">
          <b-card-header header-tag="header" role="tab">
            <h6 class="m-0">
              <a v-b-toggle.accordion-6 class="text-dark" href="javascript: void(0);">TRT's</a>
            </h6>
          </b-card-header>
          <b-collapse id="accordion-6" visible accordion="my-accordion-6" role="tabpanel">
            <b-card-body>

              <div v-if="!updating">
                <ejs-grid :dataSource="freteCotaTrtsData"
                          ref="dataGridTrts"
                          :actionBegin="changePageTrts"
                          :allowFiltering="false"
                          :allowPdfExport="true"
                          :allowExcelExport="true"
                          :allowPaging="true"
                          :enableColumnVirtualization="true"
                          :filterSettings=" { type: 'Excel' }"
                          :recordDoubleClick="recDblClickTrt"
                          :pageSettings="pageSetsTrts"
                          :toolbar="toolbar"
                          :selectionSettings="{ mode: 'Row', type: 'Multiple' }"
                          :scrollSettings="{enableColumnScrolling: true, enableRowScrolling: true}">
                  <e-columns>
                    <e-column field="_id" headerText="ID" textAlign="Left"></e-column>
                    <e-column field="cepini" headerText="CEP Início" width="120" textAlign="Right"></e-column>
                    <e-column field="cepfim" headerText="CEP Fim" width="120" textAlign="Right"></e-column>
                    <e-column field="destino" headerText="Cidade" textAlign="Right"></e-column>
                    <e-column field="estado" headerText="Estado" width="120" textAlign="Right"></e-column>
                    <e-column field="trtperc" template="templtrtperc" headerText="Perc(%)" width="120" textAlign="Right"></e-column>
                    <e-column field="trtmin" template="templtrtmin" headerText="Mínimo(R$)" width="120" textAlign="Right"></e-column>
                    <e-column field="trtmax" template="templtrtmax" headerText="Máximo(R$)" width="120" textAlign="Right"></e-column>
                    <e-column field="trtfixo" template="templtrtfixo" headerText="Fixo(R$)" width="120" textAlign="Right"></e-column>
                  </e-columns>
                  <template v-slot:templtrtperc="{data}">
                    <div> {{formatDecimal(data.trtperc)}} </div>
                  </template>
                  <template v-slot:templtrtmin="{data}">
                    <div> {{formatDecimal(data.trtmin)}} </div>
                  </template>
                  <template v-slot:templtrtmax="{data}">
                    <div> {{formatDecimal(data.trtmax)}} </div>
                  </template>
                  <template v-slot:templtrtfixo="{data}">
                    <div> {{formatDecimal(data.trtfixo)}} </div>
                  </template>

                </ejs-grid>
              </div>

            </b-card-body>
          </b-collapse>
        </div>
      </div>


      <div class="card">
        <div class="card-body">
          <b-card-header header-tag="header" role="tab">
            <h6 class="m-0">
              <a v-b-toggle.accordion-7 class="text-dark" href="javascript: void(0);">TDA's</a>
            </h6>
          </b-card-header>
          <b-collapse id="accordion-7" visible accordion="my-accordion-7" role="tabpanel">
            <b-card-body>
              <div v-if="!updating">
                <ejs-grid :dataSource="freteCotaTdasData"
                          ref="dataGridTdas"
                          :actionBegin="changePageTdas"
                          :allowFiltering="false"
                          :allowPdfExport="true"
                          :allowExcelExport="true"
                          :allowPaging="true"
                          :enableColumnVirtualization="true"
                          :filterSettings=" { type: 'Excel' }"
                          :recordDoubleClick="recDblClickTda"
                          :pageSettings="pageSetsTdas"
                          :toolbar="toolbar"
                          :selectionSettings="{ mode: 'Row', type: 'Multiple' }"
                          :scrollSettings="{enableColumnScrolling: true, enableRowScrolling: true}">
                  <e-columns>
                    <e-column field="_id" headerText="ID" textAlign="Left"></e-column>
                    <e-column field="cepini" headerText="CEP Início" width="120" textAlign="Right"></e-column>
                    <e-column field="cepfim" headerText="CEP Fim" width="120" textAlign="Right"></e-column>
                    <e-column field="destino" headerText="Cidade" textAlign="Right"></e-column>
                    <e-column field="estado" headerText="Estado" width="120" textAlign="Right"></e-column>
                    <e-column field="tdaperc" template="templtdaperc" headerText="Perc(%)" width="120" textAlign="Right"></e-column>
                    <e-column field="tdamin" template="templtdamin" headerText="Mínimo(R$)" width="120" textAlign="Right"></e-column>
                    <e-column field="tdamax" template="templtdamax" headerText="Máximo(R$)" width="120" textAlign="Right"></e-column>
                    <e-column field="tdafixo" template="templtdafixo" headerText="Fixo(R$)" width="120" textAlign="Right"></e-column>
                  </e-columns>
                  <template v-slot:templtdaperc="{data}">
                    <div> {{formatDecimal(data.tdaperc)}} </div>
                  </template>
                  <template v-slot:templtdamin="{data}">
                    <div> {{formatDecimal(data.tdamin)}} </div>
                  </template>
                  <template v-slot:templtdamax="{data}">
                    <div> {{formatDecimal(data.tdamax)}} </div>
                  </template>
                  <template v-slot:templtdafixo="{data}">
                    <div> {{formatDecimal(data.tdafixo)}} </div>
                  </template>
                </ejs-grid>
              </div>
            </b-card-body>
          </b-collapse>
        </div>
      </div>



      <div class="card">
        <div class="card-body">
          <b-card-header header-tag="header" role="tab">
            <h6 class="m-0">
              <a v-b-toggle.accordion-14 class="text-dark" href="javascript: void(0);">TDE's</a>
            </h6>
          </b-card-header>
          <b-collapse id="accordion-14" visible accordion="my-accordion-14" role="tabpanel">
            <b-card-body>


              <div v-if="!updating">
                <ejs-grid :dataSource="freteCotaTdesData"
                          ref="dataGridTdes"
                          :actionBegin="changePageTdes"
                          :allowFiltering="false"
                          :allowPdfExport="true"
                          :allowExcelExport="true"
                          :allowPaging="true"
                          :enableColumnVirtualization="true"
                          :filterSettings=" { type: 'Excel' }"
                          :recordDoubleClick="recDblClickTde"
                          :pageSettings="pageSetsTdes"
                          :toolbar="toolbar"
                          :selectionSettings="{ mode: 'Row', type: 'Multiple' }"
                          :scrollSettings="{enableColumnScrolling: true, enableRowScrolling: true}">
                  <e-columns>
                    <e-column field="_id" headerText="ID" textAlign="Left"></e-column>
                    <e-column field="cnpj" headerText="CNPJ" width="120" textAlign="Left"></e-column>
                    <e-column field="nome" headerText="Nome" width="220" textAlign="Left"></e-column>
                    <e-column field="tdeperc" template="templtdeperc" headerText="Perc(%)" width="120" textAlign="Right"></e-column>
                    <e-column field="tdemin" template="templtdemin" headerText="Mínimo(R$)" width="120" textAlign="Right"></e-column>
                    <e-column field="tdemax" template="templtdemax" headerText="Máximo(R$)" width="120" textAlign="Right"></e-column>
                    <e-column field="tdefixo" template="templtdefixo" headerText="Fixo(R$)" width="120" textAlign="Right"></e-column>
                  </e-columns>
                  <template v-slot:templtdeperc="{data}">
                    <div> {{formatDecimal(data.tdeperc)}} </div>
                  </template>
                  <template v-slot:templtdemin="{data}">
                    <div> {{formatDecimal(data.tdemin)}} </div>
                  </template>
                  <template v-slot:templtdemax="{data}">
                    <div> {{formatDecimal(data.tdemax)}} </div>
                  </template>
                  <template v-slot:templtdefixo="{data}">
                    <div> {{formatDecimal(data.tdefixo)}} </div>
                  </template>
                </ejs-grid>
              </div>

            </b-card-body>
          </b-collapse>
        </div>
      </div>




      <div class="card">
        <div class="card-body">
          <b-card-header header-tag="header" role="tab">
            <h6 class="m-0">
              <a v-b-toggle.accordion-9 class="text-dark" href="javascript: void(0);">Taxas Adicionais</a>
            </h6>
          </b-card-header>
          <b-collapse id="accordion-9" visible accordion="my-accordion-9" role="tabpanel">
            <b-card-body>


              <div v-if="!updating">
                <ejs-grid :dataSource="freteCotaAdicsData"
                          ref="dataGridTdes"
                          :actionBegin="changePageAdics"
                          :allowFiltering="false"
                          :allowPdfExport="true"
                          :allowExcelExport="true"
                          :allowPaging="true"
                          :enableColumnVirtualization="true"
                          :filterSettings=" { type: 'Excel' }"
                          :recordDoubleClick="recDblClickAdic"
                          :pageSettings="pageSetsAdics"
                          :toolbar="toolbar"
                          :selectionSettings="{ mode: 'Row', type: 'Multiple' }"
                          :scrollSettings="{enableColumnScrolling: true, enableRowScrolling: true}">
                  <e-columns>
                    <e-column field="_id" headerText="ID" textAlign="Left"></e-column>
                    <e-column field="cnpj" headerText="CNPJ" width="100" textAlign="Left"></e-column>
                    <e-column field="descricao" headerText="Descrição" width="250" textAlign="Left"></e-column>
                    <e-column field="destcnpj" headerText="CNPJ" width="150" textAlign="Left"></e-column>
                    <e-column field="destnome" headerText="Nome" width="250" textAlign="Left"></e-column>
                    <e-column field="vlrfixo" template="templtvlrfixo" headerText="Fixo(R$)" width="120" textAlign="Right"></e-column>
                    <e-column field="vlrpeso" template="templtvlrpeso" headerText="Peso(R$)" width="120" textAlign="Right"></e-column>
                    <e-column field="vlrmin" template="templtvlrmin" headerText="Mínimo(R$)" width="120" textAlign="Right"></e-column>
                    <e-column field="vlrmax" template="templtvlrmax" headerText="Máximo(R$)" width="120" textAlign="Right"></e-column>
                  </e-columns>
                  <template v-slot:templtvlrfixo="{data}">
                    <div> {{formatDecimal(data.vlrfixo)}} </div>
                  </template>
                  <template v-slot:templtvlrpeso="{data}">
                    <div> {{formatDecimal(data.vlrpeso)}} </div>
                  </template>
                  <template v-slot:templtvlrmin="{data}">
                    <div> {{formatDecimal(data.vlrmin)}} </div>
                  </template>
                  <template v-slot:templtvlrmax="{data}">
                    <div> {{formatDecimal(data.vlrmax)}} </div>
                  </template>
                </ejs-grid>
              </div>

            </b-card-body>
          </b-collapse>
        </div>
      </div>



      <div class="card">
        <div class="card-body">
          <b-card-header header-tag="header" role="tab">
            <h6 class="m-0">
              <a v-b-toggle.accordion-15 class="text-dark" href="javascript: void(0);">Taxas Cep</a>
            </h6>
          </b-card-header>
          <b-collapse id="accordion-15" visible accordion="my-accordion-15" role="tabpanel">
            <b-card-body>


              <div v-if="!updating">
                <ejs-grid :dataSource="freteCotaCepPesosData"
                          ref="dataGridTdes"
                          :actionBegin="changePageCepPesos"
                          :allowFiltering="false"
                          :allowPdfExport="true"
                          :allowExcelExport="true"
                          :allowPaging="true"
                          :enableColumnVirtualization="true"
                          :filterSettings=" { type: 'Excel' }"
                          :recordDoubleClick="recDblClickCepPeso"
                          :pageSettings="pageSetsCepsPesos"
                          :toolbar="toolbar"
                          :selectionSettings="{ mode: 'Row', type: 'Multiple' }"
                          :scrollSettings="{enableColumnScrolling: true, enableRowScrolling: true}">
                  <e-columns>
                    <e-column field="_id" headerText="ID" textAlign="Left"></e-column>
                    <e-column field="destino" headerText="Destino" width="100" textAlign="Left"></e-column>
                    <e-column field="estado" headerText="Estado" width="100" textAlign="Left"></e-column>
                    <e-column field="cepini" headerText="CEP Início" textAlign="Right"></e-column>
                    <e-column field="cepfim" headerText="CEP Fim" textAlign="Right"></e-column>
                    <e-column field="pesoexced" template="templpesoexced" headerText="Vlr.Peso Exced." textAlign="Right"></e-column>
                    <e-column field="pesoadic" template="templpesoadic" headerText="Vlr.Peso Adic." textAlign="Right"></e-column>

                  </e-columns>
                  <template v-slot:templpesoexced="{data}">
                    <div> {{formatDecimal(data.pesoexced)}} </div>
                  </template>
                  <template v-slot:templpesoadic="{data}">
                    <div> {{formatDecimal(data.pesoadic)}} </div>
                  </template>

                </ejs-grid>
              </div>

            </b-card-body>
          </b-collapse>
        </div>
      </div>


      <b-card-header header-tag="header" role="tab">
        <h6 class="m-0">
          <a
              v-b-toggle.accordion-16
              class="text-dark"
              href="javascript: void(0);"
          >Taxas Peso</a>
        </h6>
      </b-card-header>
      <b-collapse id="accordion-16" visible accordion="my-accordion-16" role="tabpanel">
        <b-card-body>

          <div class="row mb-4">

            <div class="table-responsive">
              <table class="table align-middle mb-0 table-nowrap">
                <thead class="table-light">
                <tr>
                  <th scope="col">CEP Inicial</th>
                  <th scope="col">CEP Final</th>
                  <th scope="col">Valor Peso Excedente (R$)</th>
                  <th scope="col">Valor Peso Adicional (R$)</th>
                  <th scope="col" class="text-end">Ações</th>
                </tr>
                </thead>
                <tbody>

                <tr v-for="data in freteCotaBaseTabData.txpesos" :key="data.pesoini">
                  <td>
                    <h5 class="font-size-14 text-truncate">
                      <span class="text-dark">
                        {{ data.cepini }}
                      </span>
                    </h5>
                  </td>
                  <td>
                    <h5 class="font-size-14 text-truncate">
                      <span class="text-dark">
                        {{ data.cepfim }}
                      </span>
                    </h5>
                  </td>
                  <td>
                    <h5 class="font-size-14 text-truncate">
                      <span class="text-dark">
                        {{ data.valor }}
                      </span>
                    </h5>
                  </td>
                  <td>
                    <h5 class="font-size-14 text-truncate">
                      <span class="text-dark">
                        {{ data.valorexced }}
                      </span>
                    </h5>
                  </td>

                  <td class="text-end">
                    <div class="button-items">
                      <b-button variant="outline-warning" @click="editarTxPeso(data)">
                        <i class="mdi mdi-pencil d-block font-size-16"></i>
                      </b-button>
                      <b-button variant="outline-danger" @click="deletarTxPeso(data.cepini)">
                        <i class="mdi mdi-trash-can d-block font-size-16"></i>
                      </b-button>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

        </b-card-body>

      </b-collapse>




      <div class="card">
        <div class="card-body">
          <b-card-header header-tag="header" role="tab">
            <h6 class="m-0">
              <a v-b-toggle.accordion-12 class="text-dark" href="javascript: void(0);">Origens / Regras</a>
            </h6>
          </b-card-header>
          <b-collapse id="accordion-12" visible accordion="my-accordion-12" role="tabpanel">
            <b-card-body>

              <div class="row">


                <div class="card col-md-6">
                  <div class="card-body">

                    <b-card-header header-tag="header" role="tab">
                      <h6 class="m-0">
                        <a
                            v-b-toggle.accordion-3
                            class="text-dark"
                            href="javascript: void(0);"
                        >CEP's de origens</a>
                      </h6>
                    </b-card-header>
                    <b-collapse id="accordion-3" visible accordion="my-accordion-3" role="tabpanel">
                      <b-card-body>

                        <div class="row mb-4">

                          <div class="table-responsive">
                            <table class="table align-middle mb-0 table-nowrap">
                              <thead class="table-light">
                              <tr>
                                <th scope="col">CEP Inicial</th>
                                <th scope="col">CEP Final</th>
                                <th scope="col">Descrição</th>
                                <th scope="col" class="text-end">Ações</th>
                              </tr>
                              </thead>
                              <tbody>

                              <tr v-for="data in freteCotaBaseTabData.origens" :key="data.cepini">
                                <td>
                                  <h5 class="font-size-14 text-truncate">
                                  <span class="text-dark">
                                    {{ data.cepini }}
                                  </span>
                                  </h5>
                                </td>
                                <td>
                                  <h5 class="font-size-14 text-truncate">
                                  <span class="text-dark">
                                    {{ data.cepfim }}
                                  </span>
                                  </h5>
                                </td>
                                <td>
                                  <h5 class="font-size-14 text-truncate">
                                  <span class="text-dark">
                                    {{ data.descricao }}
                                  </span>
                                  </h5>
                                </td>

                                <td class="text-end">
                                  <div class="button-items">
                                    <b-button variant="outline-warning" @click="editarOrigem(data)">
                                      <i class="mdi mdi-pencil d-block font-size-16"></i>
                                    </b-button>
                                    <b-button variant="outline-danger" @click="deletarOrigem(data.cepini)">
                                      <i class="mdi mdi-trash-can d-block font-size-16"></i>
                                    </b-button>
                                  </div>
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>




                      </b-card-body>

                    </b-collapse>
                  </div>
                </div>



                <div class="card col-md-12">
                  <div class="card-body">

                    <b-card-header header-tag="header" role="tab">
                      <h6 class="m-0">
                        <a
                            v-b-toggle.accordion-4
                            class="text-dark"
                            href="javascript: void(0);"
                        >Regras de Desconto</a>
                      </h6>
                    </b-card-header>
                    <b-collapse id="accordion-4" visible accordion="my-accordion-4" role="tabpanel">
                      <b-card-body>

                        <div class="row mb-4">

                          <div class="table-responsive">
                            <table class="table align-middle mb-0 table-nowrap">
                              <thead class="table-light">
                              <tr>
                                <th scope="col">Nome</th>
                                <th scope="col">Tipo</th>
                                <th scope="col">CEP Inicial</th>
                                <th scope="col">CEP Final</th>
                                <th scope="col">Transportadora</th>
                                <th scope="col" class="text-end">Valor</th>
                                <th scope="col" class="text-end">Mínimo</th>
                                <th scope="col" class="text-end">Início</th>
                                <th scope="col" class="text-end">Fim</th>
                                <th scope="col" class="text-end">Ações</th>
                              </tr>
                              </thead>
                              <tbody>

                              <tr v-for="data in freteCotaBaseTabData.regras" :key="data.cepini">

                                <td>
                                  <h5 class="font-size-14 text-truncate">
                                  <span class="text-dark">
                                    {{ data.nome }}
                                  </span>
                                  </h5>
                                </td>
                                <td>
                                  <h5 class="font-size-14 text-truncate">
                                  <span class="text-dark">
                                    {{ data.regra }}
                                  </span>
                                  </h5>
                                </td>
                                <td>
                                  <h5 class="font-size-14 text-truncate">
                                  <span class="text-dark">
                                    {{ data.cepini }}
                                  </span>
                                  </h5>
                                </td>
                                <td>
                                  <h5 class="font-size-14 text-truncate">
                                  <span class="text-dark">
                                    {{ data.cepfim }}
                                  </span>
                                  </h5>
                                </td>
                                <td>
                                  <h5 class="font-size-14 text-truncate">
                                  <span class="text-dark">
                                    {{ data.transp }}
                                  </span>
                                  </h5>
                                </td>
                                <td class="text-end">
                                  <h5 class="font-size-14 text-truncate">
                                  <span class="text-dark">
                                    {{ formatDecimal(data.regravalor) }}
                                  </span>
                                  </h5>
                                </td>
                                <td class="text-end">
                                  <h5 class="font-size-14 text-truncate">
                                  <span class="text-dark">
                                    {{ formatDecimal(data.mincarinho) }}
                                  </span>
                                  </h5>
                                </td>
                                <td class="text-end">
                                  <h5 class="font-size-14 text-truncate">
                                  <span class="text-dark">
                                    {{ data.inivigencia }}
                                  </span>
                                  </h5>
                                </td>
                                <td class="text-end">
                                  <h5 class="font-size-14 text-truncate">
                                  <span class="text-dark">
                                    {{ data.fimvigencia }}
                                  </span>
                                  </h5>
                                </td>

                                <td class="text-end">
                                  <div class="button-items">
                                    <b-button variant="outline-warning" v-if="data.cepini" @click="editarRegra(data)">
                                      <i class="mdi mdi-pencil d-block font-size-16"></i>
                                    </b-button>
                                    <b-button variant="outline-danger" v-if="data.cepini" @click="deletarRegra(data.cepini)">
                                      <i class="mdi mdi-trash-can d-block font-size-16"></i>
                                    </b-button>
                                  </div>
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>




                      </b-card-body>

                    </b-collapse>
                  </div>
                </div>


              </div>



            </b-card-body>
          </b-collapse>
        </div>
      </div>



    </div>




    <b-modal size="lg"
             :title="baseTrtData._id && baseTrtData._id !== null ? `Editando Base TRT (${baseTrtData._id})` : 'Criando nova Base TRT'"
             v-model="showModalBaseTrt" centered hide-footer>
      <div>

        <div class="card-body">
          <div class="row mb-3">

            <div class="col-md-3">
              <label for="destino">Destino</label>
              <div class="position-relative">
                <input id="destino" type="text" v-model="baseTrtData.destino" class="form-control"
                       placeholder="Destino" :class="{ 'is-invalid': submittedBaseTrt && !baseTrtData.destino }" />
                <div v-if="submittedBaseTrt && !baseTrtData.destino" class="invalid-feedback">
                  <span>Campo destino obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>


            <div class="col-sm-3">
              <div class="mb-3">
                <label for="estado">Estado</label>
                <select id="estado" v-model="baseTrtData.estado" class="form-control"
                        :class="{ 'is-invalid': submittedBaseTrt && !baseTrtData.estado }">
                  <option value="AC">Acre</option>
                  <option value="AL">Alagoas</option>
                  <option value="AP">Amapá</option>
                  <option value="AM">Amazonas</option>
                  <option value="BA">Bahia</option>
                  <option value="CE">Ceará</option>
                  <option value="ES">Espírito Santo</option>
                  <option value="GO">Goiás</option>
                  <option value="MA">Maranhão</option>
                  <option value="MT">Mato Grosso</option>
                  <option value="MS">Mato Grosso do Sul</option>
                  <option value="MG">Minas Gerais</option>
                  <option value="PA">Pará</option>
                  <option value="PB">Paraíba</option>
                  <option value="PR">Paraná</option>
                  <option value="PE">Pernambuco</option>
                  <option value="PI">Piauí</option>
                  <option value="RJ">Rio de Janeiro</option>
                  <option value="RN">Rio Grande do Norte</option>
                  <option value="RS">Rio Grande do Sul</option>
                  <option value="RO">Rondônia</option>
                  <option value="RR">Roraima</option>
                  <option value="SC">Santa Catarina</option>
                  <option value="SP">São Paulo</option>
                  <option value="SE">Sergipe</option>
                  <option value="TO">Tocantins</option>
                  <option value="DF">Distrito Federal</option>
                </select>
                <div v-if="submittedBaseTrt && !baseTrtData.estado" class="invalid-feedback">
                  <span>Campo estado obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>


            <div class="col-md-3">
              <label for="cepini">CEP Início</label>
              <div class="position-relative">
                <input id="cepini" type="text" v-model="baseTrtData.cepini" class="form-control"
                       placeholder="CEP Início" :class="{ 'is-invalid': submittedBaseTrt && !baseTrtData.cepini }" />
                <div v-if="submittedBaseTrt && !baseTrtData.cepini" class="invalid-feedback">
                  <span>Campo CEP Início obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <label for="cepfim">CEP Final</label>
              <div class="position-relative">
                <input id="cepfim" type="text" v-model="baseTrtData.cepfim" class="form-control"
                       placeholder="CEP Final" :class="{ 'is-invalid': submittedBaseTrt && !baseTrtData.cepfim }" />
                <div v-if="submittedBaseTrt && !baseTrtData.cepfim" class="invalid-feedback">
                  <span>Campo CEP Início obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

          </div>

          <div class="row mb-3">

            <div class="col-md-3">
              <label for="trtperc">TRT(%)</label>
              <div class="position-relative">
                <input id="trtperc" type="number" v-model="baseTrtData.trtperc" class="form-control text-end"
                       placeholder="TRT(%)" />
              </div>
            </div>

            <div class="col-md-3">
              <label for="trtmin">TRT Vlr.Mín.</label>
              <div class="position-relative">
                <input id="trtmin" type="number" v-model="baseTrtData.trtmin" class="form-control text-end"
                       placeholder="TRT Vlr.Mín." />
              </div>
            </div>

            <div class="col-md-3">
              <label for="trtmax">TRT Vlr.Máx.</label>
              <div class="position-relative">
                <input id="trtmax" type="number" v-model="baseTrtData.trtmax" class="form-control text-end"
                       placeholder="TRT Vlr.Máx." />
              </div>
            </div>

            <div class="col-md-3">
              <label for="trtfixo">TRT Vlr.Fixo</label>
              <div class="position-relative">
                <input id="trtfixo" type="number" v-model="baseTrtData.trtfixo" class="form-control text-end"
                       placeholder="TRT Vlr.Fixo" />
              </div>
            </div>

          </div>

          <div class="row mb-3">

            <div class="col-sm-3">
              <div class="mb-3">
                <label for="subtotal">Sub Total (Default 7)</label>
                <select
                    id="subtotal"
                    v-model="baseTrtData.subtotal"
                    class="form-control">
                  <option value="5">SubTotal 5</option>
                  <option value="7">SubTotal 7</option>
                </select>

              </div>
            </div>



            <div class="col-md-3">
              <label for="trtprazo">Prazo Dias (+)</label>
              <div class="position-relative">
                <input id="trtprazo" type="number" v-model="baseTrtData.prazo" class="form-control text-end"
                       placeholder="Prazo Dias (+)" />
              </div>
            </div>

          </div>


        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalBaseTrt = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button variant="outline-danger" class="ms-1" @click="exclBaseTrt(baseTrtData._id)" v-if="baseTrtData._id && baseTrtData._id !== null">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Excluir
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" @click="confBaseTrt">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>





    <b-modal size="lg"
             title="Alteração Global em Tabela TRT"
             v-model="showModalBaseGlobalTrt" centered hide-footer>
      <div>

        <div class="card-body">

          <div class="row mb-3">

            <b-alert show dismissible variant="warning">
              <i class="mdi mdi-alert me-2"></i>Todas as linhas ta tabela serão alteradas
            </b-alert>

          </div>

          <div class="row mb-2">

            <div class="col-sm-6">
              <div class="mb-3">
                <label for="subtotal">Sub Total (Default 7)</label>
                <select
                    id="subtotal"
                    v-model="baseGlobalTrtData.subtotal"
                    class="form-control">
                  <option value="5">SubTotal 5</option>
                  <option value="7">SubTotal 7</option>
                </select>

              </div>
            </div>

          </div>

        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalBaseGlobalTrt = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" @click="confBaseGlobalTrt">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal size="lg"
             title="Alteração Global em Tabela TDE"
             v-model="showModalBaseGlobalTde" centered hide-footer>
      <div>

        <div class="card-body">

          <div class="row mb-3">

            <b-alert show dismissible variant="warning">
              <i class="mdi mdi-alert me-2"></i>Todas as linhas ta tabela serão alteradas
            </b-alert>

          </div>

          <div class="row mb-2">

            <div class="col-sm-6">
              <div class="mb-3">
                <label for="tdeorivlr">Sub Total (Default Subtotal 5)</label>
                <select
                    id="tdeorivlr"
                    v-model="baseGlobalTdeData.tdeorivlr"
                    class="form-control">
                  <option value="sub5">Subtotal 5 (Default)</option>
                  <option value="sub4frtpes">Subtotal 4 + Frete Peso</option>
                </select>

              </div>
            </div>

          </div>

        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalBaseGlobalTde = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" @click="confBaseGlobalTde">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>



    <b-modal size="lg"
             :title="baseTdaData._id && baseTdaData._id !== null ? `Editando Base TDA (${baseTdaData._id})` : 'Criando nova Base TDA'"
             v-model="showModalBaseTda" centered hide-footer>
      <div>

        <div class="card-body">
          <div class="row mb-3">

            <div class="col-md-3">
              <label for="destino">Destino</label>
              <div class="position-relative">
                <input id="destino" type="text" v-model="baseTdaData.destino" class="form-control"
                       placeholder="Destino" :class="{ 'is-invalid': submittedBaseTda && !baseTdaData.destino }" />
                <div v-if="submittedBaseTda && !baseTdaData.destino" class="invalid-feedback">
                  <span>Campo destino obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>


            <div class="col-sm-3">
              <div class="mb-3">
                <label for="estado">Estado</label>
                <select id="estado" v-model="baseTdaData.estado" class="form-control"
                        :class="{ 'is-invalid': submittedBaseTda && !baseTdaData.estado }">
                  <option value="AC">Acre</option>
                  <option value="AL">Alagoas</option>
                  <option value="AP">Amapá</option>
                  <option value="AM">Amazonas</option>
                  <option value="BA">Bahia</option>
                  <option value="CE">Ceará</option>
                  <option value="ES">Espírito Santo</option>
                  <option value="GO">Goiás</option>
                  <option value="MA">Maranhão</option>
                  <option value="MT">Mato Grosso</option>
                  <option value="MS">Mato Grosso do Sul</option>
                  <option value="MG">Minas Gerais</option>
                  <option value="PA">Pará</option>
                  <option value="PB">Paraíba</option>
                  <option value="PR">Paraná</option>
                  <option value="PE">Pernambuco</option>
                  <option value="PI">Piauí</option>
                  <option value="RJ">Rio de Janeiro</option>
                  <option value="RN">Rio Grande do Norte</option>
                  <option value="RS">Rio Grande do Sul</option>
                  <option value="RO">Rondônia</option>
                  <option value="RR">Roraima</option>
                  <option value="SC">Santa Catarina</option>
                  <option value="SP">São Paulo</option>
                  <option value="SE">Sergipe</option>
                  <option value="TO">Tocantins</option>
                  <option value="DF">Distrito Federal</option>
                </select>
                <div v-if="submittedBaseTda && !baseTdaData.estado" class="invalid-feedback">
                  <span>Campo estado obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>


            <div class="col-md-3">
              <label for="cepini">CEP Início</label>
              <div class="position-relative">
                <input id="cepini" type="text" v-model="baseTdaData.cepini" class="form-control"
                       placeholder="CEP Início" :class="{ 'is-invalid': submittedBaseTda && !baseTdaData.cepini }" />
                <div v-if="submittedBaseTda && !baseTdaData.cepini" class="invalid-feedback">
                  <span>Campo CEP Início obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <label for="cepfim">CEP Final</label>
              <div class="position-relative">
                <input id="cepfim" type="text" v-model="baseTdaData.cepfim" class="form-control"
                       placeholder="CEP Final" :class="{ 'is-invalid': submittedBaseTda && !baseTdaData.cepfim }" />
                <div v-if="submittedBaseTda && !baseTdaData.cepfim" class="invalid-feedback">
                  <span>Campo CEP Início obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

          </div>

          <div class="row mb-3">

            <div class="col-md-3">
              <label for="tdaperc">TDA(%)</label>
              <div class="position-relative">
                <input id="tdaperc" type="number" v-model="baseTdaData.tdaperc" class="form-control text-end"
                       placeholder="TDA(%)" />
              </div>
            </div>

            <div class="col-md-3">
              <label for="tdamin">TDA Vlr.Mín.</label>
              <div class="position-relative">
                <input id="tdamin" type="number" v-model="baseTdaData.tdamin" class="form-control text-end"
                       placeholder="TDA Vlr.Mín." />
              </div>
            </div>

            <div class="col-md-3">
              <label for="tdamax">TDA Vlr.Máx.</label>
              <div class="position-relative">
                <input id="tdamax" type="number" v-model="baseTdaData.tdamax" class="form-control text-end"
                       placeholder="TDA Vlr.Máx." />
              </div>
            </div>

            <div class="col-md-3">
              <label for="tdafixo">TDA Vlr.Fixo</label>
              <div class="position-relative">
                <input id="tdafixo" type="number" v-model="baseTdaData.tdafixo" class="form-control text-end"
                       placeholder="TDA Vlr.Fixo" />
              </div>
            </div>

          </div>


        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalBaseTda = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button variant="outline-danger" class="ms-1" @click="exclBaseTda(baseTdaData._id)" v-if="baseTdaData._id && baseTdaData._id !== null">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Excluir
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" @click="confBaseTda">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>



    <b-modal size="lg"
             :title="baseTdeData._id && baseTdeData._id !== null ? `Editando Base TDE (${baseTdeData._id})` : 'Criando nova Base TDE'"
             v-model="showModalBaseTde" centered hide-footer>
      <div>

        <div class="card-body">
          <div class="row mb-3">



            <div class="col-md-4">
              <label for="cnpj">CNPJ</label>
              <div class="position-relative">
                <input id="cnpj" type="text" v-model="baseTdeData.cnpj" class="form-control"
                       placeholder="CNPJ" :class="{ 'is-invalid': submittedBaseTde && !baseTdeData.cnpj }" />
                <div v-if="submittedBaseTde && !baseTdeData.cnpj" class="invalid-feedback">
                  <span>Campo CNPJ obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-8">
              <label for="nome">Nome</label>
              <div class="position-relative">
                <input id="nome" type="text" v-model="baseTdeData.nome" class="form-control"
                       placeholder="nome" :class="{ 'is-invalid': submittedBaseTde && !baseTdeData.nome }" />
                <div v-if="submittedBaseTde && !baseTdeData.nome" class="invalid-feedback">
                  <span>Campo nome obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>


          </div>

          <div class="row mb-3">

            <div class="col-md-3">
              <label for="tdeperc">TDE(%)</label>
              <div class="position-relative">
                <input id="tdeperc" type="number" v-model="baseTdeData.tdeperc" class="form-control text-end"
                       placeholder="TDE(%)" />
              </div>
            </div>

            <div class="col-md-3">
              <label for="tdemin">TDE Vlr.Mín.</label>
              <div class="position-relative">
                <input id="tdemin" type="number" v-model="baseTdeData.tdemin" class="form-control text-end"
                       placeholder="TDE Vlr.Mín." />
              </div>
            </div>

            <div class="col-md-3">
              <label for="tdemax">TDE Vlr.Máx.</label>
              <div class="position-relative">
                <input id="tdemax" type="number" v-model="baseTdeData.tdemax" class="form-control text-end"
                       placeholder="TDE Vlr.Máx." />
              </div>
            </div>

            <div class="col-md-3">
              <label for="tdefixo">TDE Vlr.Fixo</label>
              <div class="position-relative">
                <input id="tdefixo" type="number" v-model="baseTdeData.tdefixo" class="form-control text-end"
                       placeholder="TDE Vlr.Fixo" />
              </div>
            </div>

          </div>

          <div class="row mb-3">

            <div class="col-md-6">
              <div class="mb-3">
                <label for="tdeorivlr">Origem Valor</label>
                <select id="tdeorivlr" v-model="baseTdeData.tdeorivlr" class="form-control">
                  <option value="sub5">Subtotal 5 (Default)</option>
                  <option value="sub4frtpes">Subtotal 4 + Frete Peso</option>
                </select>
              </div>
            </div>

            <div class="col-md-3">
              <label for="tdeprazo">Prazo Dias (+)</label>
              <div class="position-relative">
                <input id="tdeprazo" type="number" v-model="baseTdeData.prazo" class="form-control text-end"
                       placeholder="Prazo Dias (+)" />
              </div>
            </div>

          </div>


        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalBaseTde = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button variant="outline-danger" class="ms-1" @click="exclBaseTde(baseTdeData._id)" v-if="baseTdeData._id && baseTdeData._id !== null">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Excluir
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" @click="confBaseTde">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal size="lg"
             :title="taxaAdicData._id && taxaAdicData._id !== null ? `Editando Taxa Adicional (${taxaAdicData._id})` : 'Criando nova Taxa Adicional'"
             v-model="showModalTaxaAdic" centered hide-footer>
      <div>

        <div class="card-body">

          <div class="row mb-3">

            <div class="col-md-6">
              <label for="adicdescricao">Descrição</label>
              <div class="position-relative">
                <input id="adicdescricao" type="text" v-model="taxaAdicData.descricao" class="form-control"
                       placeholder="Descrição" :class="{ 'is-invalid': submittedTaxaAdic && !taxaAdicData.descricao }" />
                <div v-if="submittedTaxaAdic && !taxaAdicData.descricao" class="invalid-feedback">
                  <span>Campo descrição obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <label for="adiccnpj">CNPJ</label>
              <div class="position-relative">
                <input id="adiccnpj" type="text" v-model="taxaAdicData.cnpj" class="form-control"
                       placeholder="CNPJ" :class="{ 'is-invalid': submittedTaxaAdic && !taxaAdicData.cnpj }" />
                <div v-if="submittedTaxaAdic && !taxaAdicData.cnpj" class="invalid-feedback">
                  <span>Campo CNPJ obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <label for="adicdestcnpjdest">CNPJ Destinatário</label>
              <div class="position-relative">
                <input id="adicdestcnpjdest" type="text" v-model="taxaAdicData.destcnpj" class="form-control"
                       placeholder="CNPJ Destinatário" :class="{ 'is-invalid': submittedTaxaAdic && !taxaAdicData.destcnpj }" />
                <div v-if="submittedTaxaAdic && !taxaAdicData.destcnpj" class="invalid-feedback">
                  <span>Campo CNPJ Destinatário obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

          </div>


          <div class="row mb-2">

            <div class="col-md-12">
              <label for="adicdestnome">Nome Destinatário</label>
              <div class="position-relative">
                <input id="adicdestnome" type="text" v-model="taxaAdicData.destnome" class="form-control"
                       placeholder="Nome Destinatário" :class="{ 'is-invalid': submittedTaxaAdic && !taxaAdicData.destnome }" />
                <div v-if="submittedTaxaAdic && !taxaAdicData.destnome" class="invalid-feedback">
                  <span>Campo Nome Destinatário obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

          </div>

          <div class="row mb-2">

            <div class="col-md-3">
              <label for="adicvlrfixo">Valor Fixo</label>
              <div class="position-relative">
                <input id="adicvlrfixo" type="number" v-model="taxaAdicData.vlrfixo" class="form-control text-end"
                       placeholder="Valor Fixo" />
              </div>
            </div>

            <div class="col-md-3">
              <label for="adicvlrpeso">Valor Peso</label>
              <div class="position-relative">
                <input id="adicvlrpeso" type="number" v-model="taxaAdicData.vlrpeso" class="form-control text-end"
                       placeholder="Valor Peso" />
              </div>
            </div>

            <div class="col-md-3">
              <label for="adicvlrmin">Valor Mínimo</label>
              <div class="position-relative">
                <input id="adicvlrmin" type="number" v-model="taxaAdicData.vlrmin" class="form-control text-end"
                       placeholder="Valor Mínimo" />
              </div>
            </div>

            <div class="col-md-3">
              <label for="adicvlrmax">Valor Máximo</label>
              <div class="position-relative">
                <input id="adicvlrmax" type="number" v-model="taxaAdicData.vlrmax" class="form-control text-end"
                       placeholder="Valor Máximo" />
              </div>
            </div>

          </div>

          <div class="row mb-2">

            <div class="col-md-6">
              <label for="adicvlrpercnf">Porcentagem Sobre NF</label>
              <div class="position-relative">
                <input id="adicvlrpercnf" type="number" v-model="taxaAdicData.percnf" class="form-control text-end"
                       placeholder="Porcentagem Sobre NF" />
              </div>
            </div>

            <div class="col-md-6">
              <label for="adicvlrpercsub5">Porcentagem Sobre SubTotal5</label>
              <div class="position-relative">
                <input id="adicvlrpercsub5" type="number" v-model="taxaAdicData.percsub5" class="form-control text-end"
                       placeholder="Porcentagem Sobre SubTotal5" />
              </div>
            </div>

          </div>

          <div class="row mb-2">


            <div class="col-md-6">
              <label for="adicvlrpercsub4frpe">Porcentagem SubTotal4 + FretePeso</label>
              <div class="position-relative">
                <input id="adicvlrpercsub4frpe" type="number" v-model="taxaAdicData.percsub4frpe" class="form-control text-end"
                       placeholder="Porcentagem SubTotal4 + FretePeso" />
              </div>
            </div>


          </div>


        </div>




        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalTaxaAdic = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button variant="outline-danger"
                    v-if="taxaAdicData && taxaAdicData.id > 0"
                    class="ms-1" @click="exclTaxaAdic(taxaAdicData.id)">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Excluir
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" @click="confTaxaAdic">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>




    <b-modal size="lg"
             :title="cepPesoData._id && cepPesoData._id !== null ? `Editando Taxa Cep (${cepPesoData._id})` : 'Criando nova Taxa Cep'"
             v-model="showModalCepPeso" centered hide-footer>
      <div>

        <div class="card-body">

          <div class="row mb-2">

            <div class="col-md-9">
              <label for="ceppesodestino">Destino</label>
              <div class="position-relative">
                <input id="ceppesodestino" type="text" v-model="cepPesoData.destino" class="form-control"
                       placeholder="Destino" :class="{ 'is-invalid': submittedCepPeso && !cepPesoData.destino }" />
                <div v-if="submittedCepPeso && !cepPesoData.destino" class="invalid-feedback">
                  <span>Campo destino obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <label for="ceppesoestado">Estado</label>
              <div class="position-relative">
                <input id="ceppesoestado" type="text" v-model="cepPesoData.estado" class="form-control"
                       placeholder="Estado" :class="{ 'is-invalid': submittedCepPeso && !cepPesoData.estado }" />
                <div v-if="submittedCepPeso && !cepPesoData.estado" class="invalid-feedback">
                  <span>Campo Estado obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>


          </div>

          <div class="row mb-2">


            <div class="col-md-3">
              <label for="ceppesocepini">CEP Início</label>
              <div class="position-relative">
                <input id="ceppesocepini" type="number" v-model="cepPesoData.cepini" class="form-control"
                       placeholder="CEP Início" :class="{ 'is-invalid': submittedCepPeso && !cepPesoData.cepini }" />
                <div v-if="submittedCepPeso && !cepPesoData.cepini" class="invalid-feedback">
                  <span>Campo CEP Início obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <label for="ceppesocepfim">CEP Fim</label>
              <div class="position-relative">
                <input id="ceppesocepfim" type="number" v-model="cepPesoData.cepfim" class="form-control"
                       placeholder="CEP Fim" :class="{ 'is-invalid': submittedCepPeso && !cepPesoData.cepfim }" />
                <div v-if="submittedCepPeso && !cepPesoData.cepfim" class="invalid-feedback">
                  <span>Campo CEP Fim obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>


          </div>



          <div class="row mb-2">

            <div class="col-md-3">
              <label for="ceppesopercnf">Porcentagem NF</label>
              <div class="position-relative">
                <input id="ceppesopercnf" type="number" v-model="cepPesoData.percnf" class="form-control text-end"
                       placeholder="Porcentagem NF" />
              </div>
            </div>

            <div class="col-md-3">
              <label for="ceppesopercsub5">Porcentagem SubTotal5</label>
              <div class="position-relative">
                <input id="ceppesopercsub5" type="number" v-model="cepPesoData.percsub5" class="form-control text-end"
                       placeholder="Porcentagem SubTotal5" />
              </div>
            </div>

            <div class="col-md-3">
              <label for="ceppesovlrpeso">Valor Kg</label>
              <div class="position-relative">
                <input id="ceppesovlrpeso" type="number" v-model="cepPesoData.vlrpeso" class="form-control text-end"
                       placeholder="Valor Kg" />
              </div>
            </div>

            <div class="col-md-3">
              <label for="ceppesovlrfrc100">Valor Fração 100Kg</label>
              <div class="position-relative">
                <input id="ceppesovlrfrc100" type="number" v-model="cepPesoData.vlrfrc100" class="form-control text-end"
                       placeholder="Valor Fração 100Kg" />
              </div>
            </div>

          </div>

          <div class="row mb-2">

            <div class="col-md-3">
              <label for="ceppesovlrmin">Valor Mínimo</label>
              <div class="position-relative">
                <input id="ceppesovlrmin" type="number" v-model="cepPesoData.vlrmin" class="form-control text-end"
                       placeholder="Valor Mínimo" />
              </div>
            </div>

            <div class="col-md-3">
              <label for="ceppesovlrmax">Valor Máximo</label>
              <div class="position-relative">
                <input id="ceppesovlrmax" type="number" v-model="cepPesoData.vlrmax" class="form-control text-end"
                       placeholder="Valor Máximo" />
              </div>
            </div>

          </div>


        </div>

        <div class="text-end mt-5">





          <b-button variant="light" @click="showModalCepPeso = false; criarNovaFxCepPeso = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button variant="outline-danger"
                    v-if="cepPesoData && cepPesoData._id && cepPesoData._id !== null"
                    class="ms-1" @click="exclCePeso(cepPesoData._id)">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Excluir
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" @click="confCepPeso">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>




    <b-modal size="lg"
             title="Criando Nova Permissão para Empresa"
             v-model="showModalEmpresa" centered hide-footer>
      <div>

        <div class="card-body">

          <div class="row mb-3">

            <div class="col-md-12">
              <label for="empresaid">Empresa</label>
              <multiselect id="empresaid"
                           @search-change="pesqEmpresa"
                           v-model="freteCotaBaseEmprData.empresa_id"
                           placeholder="Pesquisar empresas"
                           :options="dtListPesqEmpresa"
                           :searchable="true"
                           label="nome"
                           track-by="nome"
                           :style="submittedEmprData && !freteCotaBaseEmprData.empresa_id ? 'border: 1px solid #f86c6b !important;' : ''"
                           value-prop="id">
                <template #option="slotProps">
                  <div class="row">
                    <div>
                          <span class="text-info">
                            {{ slotProps.option.id }}
                          </span>
                      <span class="mx-4" >
                          </span>
                    </div>
                    <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                    <span class="mx-4">{{ slotProps.option.cnpj }}</span>
                    <span class="mx-4"></span>
                    <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
                  </div>
                </template>
              </multiselect>
              <div v-if="submittedEmprData && !freteCotaBaseEmprData.empresa_id">
                <span class="text-danger font-size-11">Campo Empresa obrigatório, favor preencher.</span>
              </div>
            </div>



          </div>


        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalEmpresa = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" @click="confEmpresa">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal title="Importar Planilha" v-model="showModalImpPlan" centered hide-footer>
      <div>

        <div class="card-body">
          <h4 class="card-title">Selecionar planilha</h4>
          <DropZone @change="selectedFile" />
          <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>
          <div v-if="submittedImpPlan && !dropzoneFile.name">
            <span class="text-danger font-size-11">Favor selecionar o arquivo e tentar novamente.</span>
          </div>
        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalImpPlan = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confImpPlan">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>



    <b-modal
        v-model="showModalBaseRegra"
        :title="baseRegraData.id > 0 ? `Editar Regra de Desconto (${ baseRegraData.id })` : 'Criando nova Regra de Desconto'"
        size="lg" title-class="font-18" hide-footer>
      <div>

        <div class="card-body">

          <div class="row">

            <div class="col-md-6">
              <div class="mb-3">
                <label for="baseRegraDataNome">Nome da regra</label>
                <div class="position-relative">
                  <input
                      id="baseRegraDataNome"
                      v-model="baseRegraData.nome"
                      type="text"
                      class="form-control"
                      placeholder="Nome da regra"
                      :class="{'is-invalid': submittedBaseRegra && !baseRegraData.nome}"/>
                  <div v-if="submittedBaseRegra && !baseRegraData.nome" class="invalid-feedback">
                    <span>Campo nome obrigatório, favor preencher.</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3">
                <label for="baseRegraDataDescricao">Breve descrição da regra</label>
                <div class="position-relative">
                  <input
                      id="baseRegraDataDescricao"
                      v-model="baseRegraData.descricao"
                      type="text"
                      class="form-control"
                      placeholder="Breve descrição da regra"/>
                </div>
              </div>
            </div>

          </div>


          <div class="row mt-2" v-if="!baseRegraData.id">


            <b-card-header header-tag="header" role="tab">
              <h6 class="m-0">
                <a v-b-toggle.accordion-regioes class="text-dark" href="javascript: void(0);">Regiões</a>
              </h6>
            </b-card-header>
            <b-collapse id="accordion-regioes" v-model="visibleRegioes" accordion="my-accordion-regioes" role="tabpanel">
              <b-card-body>

                <b-form-group v-slot="{ ariaDescribedby }" class="form-radio-warning">
                  <b-form-checkbox v-model="regSelBrasil"
                                   @change="changeRegiaoBR"
                                   :aria-describedby="ariaDescribedby"
                                   name="brasil"
                                   value="brasil">Brasil todo</b-form-checkbox>
                </b-form-group>

                <div class="d-flex flex-wrap gap-2 justify-content-center">
                  <h6 class="w-100"><strong>Por região</strong></h6>
                  <div>
                    <b-form-checkbox
                        v-model="regSelSudeste"
                        @change="changeRegiao"
                        name="sudeste"
                        value="sudeste">
                      Região Sudeste
                    </b-form-checkbox>
                  </div>

                  <div>
                    <b-form-checkbox
                        v-model="regSelSul"
                        @change="changeRegiao"
                        name="sul"
                        value="sul">
                      Região Sul
                    </b-form-checkbox>
                  </div>

                  <div>
                    <b-form-checkbox
                        v-model="regSelNordeste"
                        @change="changeRegiao"
                        name="nordeste"
                        value="nordeste">
                      Região Nordeste
                    </b-form-checkbox>
                  </div>

                  <div>
                    <b-form-checkbox
                        v-model="regSelNorte"
                        @change="changeRegiao"
                        name="norte"
                        value="norte">
                      Região Norte
                    </b-form-checkbox>
                  </div>

                  <div>
                    <b-form-checkbox
                        v-model="regSelCentrooeste"
                        @change="changeRegiao"
                        name="centrooeste"
                        value="centrooeste">
                      Região Centro-oeste
                    </b-form-checkbox>
                  </div>
                </div>

              </b-card-body>
            </b-collapse>

          </div>


          <div class="row mt-2" v-if="!baseRegraData.id">


            <b-card-header header-tag="header" role="tab">
              <h6 class="m-0">
                <a v-b-toggle.accordion-estados class="text-dark" href="javascript: void(0);">Estados</a>
              </h6>
            </b-card-header>
            <b-collapse id="accordion-estados" v-model="visibleEstados" accordion="my-accordion-estados" role="tabpanel">
              <b-card-body>


                <div class="row">

                  <div class="col-md-6">
                    <div class="mt-2">
                      <b-form-checkbox
                          v-model="regSelEstAC"
                          @change="changeEstado"
                          name="regSelEstAC">
                        Acre
                      </b-form-checkbox>
                    </div>
                    <b-collapse id="accordion-estac" v-model="regSelEstAC" accordion="my-accordion-estac" role="tabpanel">
                      <div class="d-flex flex-wrap gap-2 justify-content-center">
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstACCap"
                              @change="changeEstado"
                              name="regSelEstACCap">
                            Capital
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstACInterior"
                              @change="changeEstado"
                              name="regSelEstACInterior">
                            Interior
                          </b-form-checkbox>
                        </div>
                      </div>
                    </b-collapse>
                  </div>



                  <div class="col-md-6">
                    <div class="mt-2">
                      <b-form-checkbox
                          v-model="regSelEstAL"
                          @change="changeEstado"
                          name="regSelEstAL">
                        Alagoas
                      </b-form-checkbox>
                    </div>
                    <b-collapse id="accordion-estal" v-model="regSelEstAL" accordion="my-accordion-estal" role="tabpanel">
                      <div class="d-flex flex-wrap gap-2 justify-content-center">
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstALCap"
                              @change="changeEstado"
                              name="regSelEstALCap">
                            Capital
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstALInterior"
                              @change="changeEstado"
                              name="regSelEstALInterior">
                            Interior
                          </b-form-checkbox>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <div class="col-md-6">
                    <div class="mt-2">
                      <b-form-checkbox
                          v-model="regSelEstAP"
                          @change="changeEstado"
                          name="regSelEstAP">
                        Amapá
                      </b-form-checkbox>
                    </div>
                    <b-collapse id="accordion-estap" v-model="regSelEstAP" accordion="my-accordion-estap" role="tabpanel">
                      <div class="d-flex flex-wrap gap-2 justify-content-center">
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstAPCap"
                              @change="changeEstado"
                              name="regSelEstAPCap">
                            Capital
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstAPInterior"
                              @change="changeEstado"
                              name="regSelEstAPInterior">
                            Interior
                          </b-form-checkbox>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <div class="col-md-6">
                    <div class="mt-2">
                      <b-form-checkbox
                          v-model="regSelEstAM"
                          @change="changeEstado"
                          name="regSelEstAM">
                        Amazonas
                      </b-form-checkbox>
                    </div>
                    <b-collapse id="accordion-estam" v-model="regSelEstAM" accordion="my-accordion-estam" role="tabpanel">
                      <div class="d-flex flex-wrap gap-2 justify-content-center">
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstAMCap"
                              @change="changeEstado"
                              name="regSelEstAMCap">
                            Capital
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstAMInterior"
                              @change="changeEstado"
                              name="regSelEstAMInterior">
                            Interior
                          </b-form-checkbox>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <div class="col-md-6">
                    <div class="mt-2">
                      <b-form-checkbox
                          v-model="regSelEstBA"
                          @change="changeEstado"
                          name="regSelEstBA">
                        Bahia
                      </b-form-checkbox>
                    </div>
                    <b-collapse id="accordion-estba" v-model="regSelEstBA" accordion="my-accordion-estba" role="tabpanel">
                      <div class="d-flex flex-wrap gap-2 justify-content-center">
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstBACap"
                              @change="changeEstado"
                              name="regSelEstBACap">
                            Capital
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstBAAreaMetr"
                              @change="changeEstado"
                              name="regSelEstBAAreaMetr">
                            Área Metropolitana
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstBAInterior"
                              @change="changeEstado"
                              name="regSelEstBAInterior">
                            Interior
                          </b-form-checkbox>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <div class="col-md-6">
                    <div class="mt-2">
                      <b-form-checkbox
                          v-model="regSelEstCE"
                          @change="changeEstado"
                          name="regSelEstCE">
                        Ceará
                      </b-form-checkbox>
                    </div>
                    <b-collapse id="accordion-estce" v-model="regSelEstCE" accordion="my-accordion-estce" role="tabpanel">
                      <div class="d-flex flex-wrap gap-2 justify-content-center">
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstCECap"
                              @change="changeEstado"
                              name="regSelEstCECap">
                            Capital
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstCEAreaMetr"
                              @change="changeEstado"
                              name="regSelEstCEAreaMetr">
                            Área Metropolitana
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstCEInterior"
                              @change="changeEstado"
                              name="regSelEstCEInterior">
                            Interior
                          </b-form-checkbox>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <div class="col-md-6">
                    <div class="mt-2">
                      <b-form-checkbox
                          v-model="regSelEstDF"
                          @change="changeEstado"
                          name="regSelEstDF">
                        Distrito Federal
                      </b-form-checkbox>
                    </div>
                    <b-collapse id="accordion-estdf" v-model="regSelEstDF" accordion="my-accordion-estdf" role="tabpanel">
                      <div class="d-flex flex-wrap gap-2 justify-content-center">
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstDFCap"
                              @change="changeEstado"
                              name="regSelEstDFCap">
                            Capital
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstDFInterior"
                              @change="changeEstado"
                              name="regSelEstDFInterior">
                            Interior
                          </b-form-checkbox>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <div class="col-md-6">
                    <div class="mt-2">
                      <b-form-checkbox
                          v-model="regSelEstES"
                          @change="changeEstado"
                          name="regSelEstES">
                        Espírito Santo
                      </b-form-checkbox>
                    </div>
                    <b-collapse id="accordion-estes" v-model="regSelEstES" accordion="my-accordion-estes" role="tabpanel">
                      <div class="d-flex flex-wrap gap-2 justify-content-center">
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstESCap"
                              @change="changeEstado"
                              name="regSelEstESCap">
                            Capital
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstESInterior"
                              @change="changeEstado"
                              name="regSelEstESInterior">
                            Interior
                          </b-form-checkbox>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <div class="col-md-6">
                    <div class="mt-2">
                      <b-form-checkbox
                          v-model="regSelEstGO"
                          @change="changeEstado"
                          name="regSelEstGO">
                        Goiás
                      </b-form-checkbox>
                    </div>
                    <b-collapse id="accordion-estgo" v-model="regSelEstGO" accordion="my-accordion-estgo" role="tabpanel">
                      <div class="d-flex flex-wrap gap-2 justify-content-center">
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstGOCap"
                              @change="changeEstado"
                              name="regSelEstGOCap">
                            Capital
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstGOInterior"
                              @change="changeEstado"
                              name="regSelEstGOInterior">
                            Interior
                          </b-form-checkbox>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <div class="col-md-6">
                    <div class="mt-2">
                      <b-form-checkbox
                          v-model="regSelEstMT"
                          @change="changeEstado"
                          name="regSelEstMT">
                        Mato Grosso
                      </b-form-checkbox>
                    </div>
                    <b-collapse id="accordion-estmt" v-model="regSelEstMT" accordion="my-accordion-estmt" role="tabpanel">
                      <div class="d-flex flex-wrap gap-2 justify-content-center">
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstMTCap"
                              @change="changeEstado"
                              name="regSelEstMTCap">
                            Capital
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstMTInterior"
                              @change="changeEstado"
                              name="regSelEstMTInterior">
                            Interior
                          </b-form-checkbox>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <div class="col-md-6">
                    <div class="mt-2">
                      <b-form-checkbox
                          v-model="regSelEstMA"
                          @change="changeEstado"
                          name="regSelEstMA">
                        Maranhão
                      </b-form-checkbox>
                    </div>
                    <b-collapse id="accordion-estma" v-model="regSelEstMA" accordion="my-accordion-estma" role="tabpanel">
                      <div class="d-flex flex-wrap gap-2 justify-content-center">
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstMACap"
                              @change="changeEstado"
                              name="regSelEstMACap">
                            Capital
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstMAInterior"
                              @change="changeEstado"
                              name="regSelEstMAInterior">
                            Interior
                          </b-form-checkbox>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <div class="col-md-6">
                    <div class="mt-2">
                      <b-form-checkbox
                          v-model="regSelEstMS"
                          @change="changeEstado"
                          name="regSelEstMS">
                        Mato Grosso do Sul
                      </b-form-checkbox>
                    </div>
                    <b-collapse id="accordion-estms" v-model="regSelEstMS" accordion="my-accordion-estms" role="tabpanel">
                      <div class="d-flex flex-wrap gap-2 justify-content-center">
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstMSCap"
                              @change="changeEstado"
                              name="regSelEstMSCap">
                            Capital
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstMSInterior"
                              @change="changeEstado"
                              name="regSelEstMSInterior">
                            Interior
                          </b-form-checkbox>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <div class="col-md-6">
                    <div class="mt-2">
                      <b-form-checkbox
                          v-model="regSelEstMG"
                          @change="changeEstado"
                          name="regSelEstMG">
                        Minas Gerais
                      </b-form-checkbox>
                    </div>
                    <b-collapse id="accordion-estes" v-model="regSelEstMG" accordion="my-accordion-estes" role="tabpanel">
                      <div class="d-flex flex-wrap gap-2 justify-content-center">
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstMGCap"
                              @change="changeEstado"
                              name="regSelEstMGCap">
                            Capital
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstMGAreaMetr"
                              @change="changeEstado"
                              name="regSelEstMGAreaMetr">
                            Área Metropolitana
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstMGInterior"
                              @change="changeEstado"
                              name="regSelEstMGInterior">
                            Interior
                          </b-form-checkbox>
                        </div>
                      </div>
                    </b-collapse>
                  </div>


                  <div class="col-md-6">
                    <div class="mt-2">
                      <b-form-checkbox
                          v-model="regSelEstPA"
                          @change="changeEstado"
                          name="regSelEstPA">
                        Pará
                      </b-form-checkbox>
                    </div>
                    <b-collapse id="accordion-estpa" v-model="regSelEstPA" accordion="my-accordion-estpa" role="tabpanel">
                      <div class="d-flex flex-wrap gap-2 justify-content-center">
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstPACap"
                              @change="changeEstado"
                              name="regSelEstPACap">
                            Capital
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstPAAreaMetr"
                              @change="changeEstado"
                              name="regSelEstPAAreaMetr">
                            Área Metropolitana
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstPAInterior"
                              @change="changeEstado"
                              name="regSelEstPAInterior">
                            Interior
                          </b-form-checkbox>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <div class="col-md-6">
                    <div class="mt-2">
                      <b-form-checkbox
                          v-model="regSelEstPR"
                          @change="changeEstado"
                          name="regSelEstPR">
                        Paraná
                      </b-form-checkbox>
                    </div>
                    <b-collapse id="accordion-estpr" v-model="regSelEstPR" accordion="my-accordion-estpr" role="tabpanel">
                      <div class="d-flex flex-wrap gap-2 justify-content-center">
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstPRCap"
                              @change="changeEstado"
                              name="regSelEstPRCap">
                            Capital
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstPRAreaMetr"
                              @change="changeEstado"
                              name="regSelEstPRAreaMetr">
                            Área Metropolitana
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstPRInterior"
                              @change="changeEstado"
                              name="regSelEstPRInterior">
                            Interior
                          </b-form-checkbox>
                        </div>
                      </div>
                    </b-collapse>
                  </div>


                  <div class="col-md-6">
                    <div class="mt-2">
                      <b-form-checkbox
                          v-model="regSelEstPB"
                          @change="changeEstado"
                          name="regSelEstPB">
                        Paraíba
                      </b-form-checkbox>
                    </div>
                    <b-collapse id="accordion-estpb" v-model="regSelEstPB" accordion="my-accordion-estpb" role="tabpanel">
                      <div class="d-flex flex-wrap gap-2 justify-content-center">
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstPBCap"
                              @change="changeEstado"
                              name="regSelEstPBCap">
                            Capital
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstPBInterior"
                              @change="changeEstado"
                              name="regSelEstPBInterior">
                            Interior
                          </b-form-checkbox>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <div class="col-md-6">
                    <div class="mt-2">
                      <b-form-checkbox
                          v-model="regSelEstPE"
                          @change="changeEstado"
                          name="regSelEstPE">
                        Pernambuco
                      </b-form-checkbox>
                    </div>
                    <b-collapse id="accordion-estpe" v-model="regSelEstPE" accordion="my-accordion-estpe" role="tabpanel">
                      <div class="d-flex flex-wrap gap-2 justify-content-center">
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstPECap"
                              @change="changeEstado"
                              name="regSelEstPECap">
                            Capital
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstPEAreaMetr"
                              @change="changeEstado"
                              name="regSelEstPEAreaMetr">
                            Área Metropolitana
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstPEInterior"
                              @change="changeEstado"
                              name="regSelEstPEInterior">
                            Interior
                          </b-form-checkbox>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <div class="col-md-6">
                    <div class="mt-2">
                      <b-form-checkbox
                          v-model="regSelEstPI"
                          @change="changeEstado"
                          name="regSelEstPI">
                        Piauí
                      </b-form-checkbox>
                    </div>
                    <b-collapse id="accordion-estpi" v-model="regSelEstPI" accordion="my-accordion-estpi" role="tabpanel">
                      <div class="d-flex flex-wrap gap-2 justify-content-center">
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstPICap"
                              @change="changeEstado"
                              name="regSelEstPICap">
                            Capital
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstPIInterior"
                              @change="changeEstado"
                              name="regSelEstPIInterior">
                            Interior
                          </b-form-checkbox>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <div class="col-md-6">
                    <div class="mt-2">
                      <b-form-checkbox
                          v-model="regSelEstRJ"
                          @change="changeEstado"
                          name="regSelEstRJ">
                        Rio de Janeiro
                      </b-form-checkbox>
                    </div>
                    <b-collapse id="accordion-estrj" v-model="regSelEstRJ" accordion="my-accordion-estrj" role="tabpanel">
                      <div class="d-flex flex-wrap gap-2 justify-content-center">
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstRJCap"
                              @change="changeEstado"
                              name="regSelEstRJCap">
                            Capital
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstRJAreaMetr"
                              @change="changeEstado"
                              name="regSelEstRJAreaMetr">
                            Área Metropolitana
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstRJInterior"
                              @change="changeEstado"
                              name="regSelEstRJInterior">
                            Interior
                          </b-form-checkbox>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <div class="col-md-6">
                    <div class="mt-2">
                      <b-form-checkbox
                          v-model="regSelEstRS"
                          @change="changeEstado"
                          name="regSelEstRS">
                        Rio Grande do Sul
                      </b-form-checkbox>
                    </div>
                    <b-collapse id="accordion-estrs" v-model="regSelEstRS" accordion="my-accordion-estrs" role="tabpanel">
                      <div class="d-flex flex-wrap gap-2 justify-content-center">
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstRSCap"
                              @change="changeEstado"
                              name="regSelEstRSCap">
                            Capital
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstRSAreaMetr"
                              @change="changeEstado"
                              name="regSelEstRSAreaMetr">
                            Área Metropolitana
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstRSInterior"
                              @change="changeEstado"
                              name="regSelEstRSInterior">
                            Interior
                          </b-form-checkbox>
                        </div>
                      </div>
                    </b-collapse>
                  </div>


                  <div class="col-md-6">
                    <div class="mt-2">
                      <b-form-checkbox
                          v-model="regSelEstRN"
                          @change="changeEstado"
                          name="regSelEstRN">
                        Rio Grande do Norte
                      </b-form-checkbox>
                    </div>
                    <b-collapse id="accordion-estrn" v-model="regSelEstRN" accordion="my-accordion-estrn" role="tabpanel">
                      <div class="d-flex flex-wrap gap-2 justify-content-center">
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstRNCap"
                              @change="changeEstado"
                              name="regSelEstRNCap">
                            Capital
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstRNInterior"
                              @change="changeEstado"
                              name="regSelEstRNInterior">
                            Interior
                          </b-form-checkbox>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <div class="col-md-6">
                    <div class="mt-2">
                      <b-form-checkbox
                          v-model="regSelEstRO"
                          @change="changeEstado"
                          name="regSelEstRO">
                        Rondônia
                      </b-form-checkbox>
                    </div>
                    <b-collapse id="accordion-estro" v-model="regSelEstRO" accordion="my-accordion-estro" role="tabpanel">
                      <div class="d-flex flex-wrap gap-2 justify-content-center">
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstROCap"
                              @change="changeEstado"
                              name="regSelEstROCap">
                            Capital
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstROInterior"
                              @change="changeEstado"
                              name="regSelEstROInterior">
                            Interior
                          </b-form-checkbox>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <div class="col-md-6">
                    <div class="mt-2">
                      <b-form-checkbox
                          v-model="regSelEstRR"
                          @change="changeEstado"
                          name="regSelEstRR">
                        Roraima
                      </b-form-checkbox>
                    </div>
                    <b-collapse id="accordion-estrr" v-model="regSelEstRR" accordion="my-accordion-estrr" role="tabpanel">
                      <div class="d-flex flex-wrap gap-2 justify-content-center">
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstRRCap"
                              @change="changeEstado"
                              name="regSelEstRRCap">
                            Capital
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstRRInterior"
                              @change="changeEstado"
                              name="regSelEstRRInterior">
                            Interior
                          </b-form-checkbox>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <div class="col-md-6">
                    <div class="mt-2">
                      <b-form-checkbox
                          v-model="regSelEstSC"
                          @change="changeEstado"
                          name="regSelEstSC">
                        Santa Catarina
                      </b-form-checkbox>
                    </div>
                    <b-collapse id="accordion-estsc" v-model="regSelEstSC" accordion="my-accordion-estsc" role="tabpanel">
                      <div class="d-flex flex-wrap gap-2 justify-content-center">
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstSCCap"
                              @change="changeEstado"
                              name="regSelEstSCCap">
                            Capital
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstSCAreaMetr"
                              @change="changeEstado"
                              name="regSelEstSCAreaMetr">
                            Área Metropolitana
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstSCInterior"
                              @change="changeEstado"
                              name="regSelEstSCInterior">
                            Interior
                          </b-form-checkbox>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <div class="col-md-6">
                    <div class="mt-2">
                      <b-form-checkbox
                          v-model="regSelEstSP"
                          @change="changeEstado"
                          name="regSelEstSP">
                        São Paulo
                      </b-form-checkbox>
                    </div>
                    <b-collapse id="accordion-estsp" v-model="regSelEstSP" accordion="my-accordion-estsp" role="tabpanel">
                      <div class="d-flex flex-wrap gap-2 justify-content-center">
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstSPCap"
                              @change="changeEstado"
                              name="regSelEstSPCap">
                            Capital
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstSPAreaMetr"
                              @change="changeEstado"
                              name="regSelEstSPAreaMetr">
                            Área Metropolitana
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstSPLitoral"
                              @change="changeEstado"
                              name="regSelEstSPLitoral">
                            Litoral
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstSPInterior"
                              @change="changeEstado"
                              name="regSelEstSPInterior">
                            Interior
                          </b-form-checkbox>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <div class="col-md-6">
                    <div class="mt-2">
                      <b-form-checkbox
                          v-model="regSelEstSE"
                          @change="changeEstado"
                          name="regSelEstSE">
                        Sergipe
                      </b-form-checkbox>
                    </div>
                    <b-collapse id="accordion-estse" v-model="regSelEstSE" accordion="my-accordion-estse" role="tabpanel">
                      <div class="d-flex flex-wrap gap-2 justify-content-center">
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstSECap"
                              @change="changeEstado"
                              name="regSelEstSECap">
                            Capital
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstSEInterior"
                              @change="changeEstado"
                              name="regSelEstSEInterior">
                            Interior
                          </b-form-checkbox>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <div class="col-md-6">
                    <div class="mt-2">
                      <b-form-checkbox
                          v-model="regSelEstTO"
                          @change="changeEstado"
                          name="regSelEstTO">
                        Tocantins
                      </b-form-checkbox>
                    </div>
                    <b-collapse id="accordion-estto" v-model="regSelEstTO" accordion="my-accordion-estto" role="tabpanel">
                      <div class="d-flex flex-wrap gap-2 justify-content-center">
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstTOCap"
                              @change="changeEstado"
                              name="regSelEstTOCap">
                            Capital
                          </b-form-checkbox>
                        </div>
                        <div>
                          <b-form-checkbox
                              v-model="regSelEstTOInterior"
                              @change="changeEstado"
                              name="regSelEstTOInterior">
                            Interior
                          </b-form-checkbox>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                </div>


                <div class="row">



                </div>





              </b-card-body>
            </b-collapse>

          </div>



          <div class="row mt-2" v-if="regiaoFaixasCeps.length === 0">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="baseRegraDataCepIni">CEP Início</label>
                <input
                    id="baseRegraDataCepIni"
                    v-model="baseRegraData.cepini"
                    type="number"
                    class="form-control"
                    placeholder="CEP Início"
                    :disabled="!insereCepManual"
                    :class="{'is-invalid': submittedBaseRegra && !baseRegraData.cepini}"/>
                <div v-if="submittedBaseRegra && !baseRegraData.cepini" class="invalid-feedback">
                  <span>Campo CEP Início obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="baseRegraDataCepFim">CEP Final</label>
                <input
                    id="baseRegraDataCepFim"
                    v-model="baseRegraData.cepfim"
                    type="number"
                    class="form-control"
                    placeholder="CEP Final"
                    :disabled="!insereCepManual"
                    :class="{'is-invalid': submittedBaseRegra && !baseRegraData.cepfim}"/>
                <div v-if="submittedBaseRegra && !baseRegraData.cepfim" class="invalid-feedback">
                  <span>Campo CEP Final obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>
          </div>




          <!--          regiaoFaixasCeps  -->

          <div class="row mt-2" v-for="data in regiaoFaixasCeps" :key="data.id">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="faixasCepsIni">CEP Início {{ data.id }}</label>
                <input
                    id="faixasCepsIni"
                    v-model="data.cepini"
                    type="number"
                    class="form-control"
                    placeholder="CEP Início"
                    :disabled="true"/>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="faixasCepsFim">CEP Final {{ data.id }}</label>
                <input
                    id="faixasCepsFim"
                    v-model="data.cepfim"
                    type="number"
                    class="form-control"
                    placeholder="CEP Final"
                    :disabled="true"/>

              </div>
            </div>
          </div>



          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="baseRegraDataRegra">Regra</label>
                <select id="baseRegraDataRegra" v-model="baseRegraData.regra" class="form-control"
                        :class="{'is-invalid': submittedBaseRegra && !baseRegraData.regra}">
                  <option value="descperc">Desconto percentual (%)</option>
                  <option value="descfixo">Desconto valor fixo (R$)</option>
                  <option value="acresperc">Acréscimo percentual (%)</option>
                  <option value="acresfixo">Acréscimo valor fixo (R$)</option>
                  <option value="fretegratis">Frete grátis</option>

                  <option value="blocktransp">Bloquear transportadora</option>
                  <option value="fixartransp">Fixar apenas uma transportadora</option>

                </select>
                <div v-if="submittedBaseRegra && !baseRegraData.regra" class="invalid-feedback">
                  <span>Campo regra obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-6" v-if="baseRegraData.regra === 'descperc' || baseRegraData.regra === 'descfixo'
            || baseRegraData.regra === 'acresperc' || baseRegraData.regra === 'acresfixo'">
              <div class="mb-3">
                <label for="baseRegraDataRegraValor">{{ baseRegraData.regra === 'descfixo' ||  baseRegraData.regra === 'acresfixo' ? 'Valor' : 'Percentual' }}</label>
                <input
                    id="baseRegraDataRegraValor"
                    v-model="baseRegraData.regravalor"
                    type="number"
                    class="form-control"
                    placeholder="Valor"
                    :class="{'is-invalid': submittedBaseRegra && (baseRegraData.regra === 'descperc' || baseRegraData.regra === 'descfixo') && !baseRegraData.regravalor}"/>
                <div v-if="submittedBaseRegra && (baseRegraData.regra === 'descperc' || baseRegraData.regra === 'descfixo') && !baseRegraData.regravalor" class="invalid-feedback">
                  <span>Campo Valor/Percentual obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-6" v-if="baseRegraData.regra === 'blocktransp' || baseRegraData.regra === 'fixartransp'">
              <div class="mb-3">
                <label for="baseRegraDataTransp">CNPJ/Raiz CNPJ Transportadora</label>
                <input
                    id="baseRegraDataTransp"
                    v-model="baseRegraData.transp"
                    type="number"
                    class="form-control"
                    placeholder="CNPJ/Raiz CNPJ Transportadora"
                    :class="{'is-invalid': submittedBaseRegra && !baseRegraData.transp}"/>
                <div v-if="submittedBaseRegra && !baseRegraData.transp" class="invalid-feedback">
                  <span>Campo CNPJ Transportadora obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

          </div>

          <hr>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="baseRegraDataMinCarinho">Valor Mínimo Nota Fiscal</label>
                <input
                    id="baseRegraDataMinCarinho"
                    v-model="baseRegraData.mincarinho"
                    type="number"
                    class="form-control"
                    placeholder="Valor Mínimo Nota Fiscal">
              </div>
            </div>
          </div>


          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="baseRegraDataIniVigencia">Data Início Vigência</label>
                <input
                    id="baseRegraDataIniVigencia"
                    v-model="baseRegraData.inivigencia"
                    type="date"
                    class="form-control"
                    placeholder="Data Início Vigência">
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="baseRegraDataFimVigencia">Data Final Vigência</label>
                <input
                    id="baseRegraDataFimVigencia"
                    v-model="baseRegraData.fimvigencia"
                    type="date"
                    class="form-control"
                    placeholder="Data Final Vigência">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="text-end mt-5">
              <b-button variant="light" @click="showModalBaseRegra = false; submittedBaseRegra = false;">
                <i class="bx bx-block font-size-16 align-middle me-2"></i>
                Cancelar
              </b-button>

              <b-button variant="outline-danger"
                        v-if="baseRegraData && baseRegraData.id > 0"
                        class="ms-1" @click="exclRegraDesc(baseRegraData.id)">
                <i class="bx bx-block font-size-16 align-middle me-2"></i>
                Excluir
              </b-button>

              <b-button type="submit" variant="success" class="ms-1" @click="confRegraDesc">
                <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                Confirmar
              </b-button>
            </div>
          </div>

        </div>

      </div>
    </b-modal>



    <b-modal size="md"
             :title="baseOrigemData._id && baseOrigemData._id !== '' ? `Editando Base Origem (${baseOrigemData.id})` : 'Criando nova Base de Origem'"
             v-model="showModalBaseOrigem" centered hide-footer>
      <div>
        <div class="card-body">

          <div class="row mb-3">
            <div class="col-md-12">
              <label for="descricao">Descrição</label>
              <div class="position-relative">
                <input id="descricao" type="text" v-model="baseOrigemData.descricao" class="form-control"
                       placeholder="Descrição"/>
              </div>
            </div>
          </div>

          <div class="row mb-3">

            <div class="col-md-6">
              <label for="cepini">CEP Início</label>
              <div class="position-relative">
                <input id="cepini" type="text" v-model="baseOrigemData.cepini" class="form-control"
                       placeholder="CEP Início" :class="{ 'is-invalid': submittedBaseOrigem && !baseOrigemData.cepini }" />
                <div v-if="submittedBaseOrigem && !baseOrigemData.cepini" class="invalid-feedback">
                  <span>Campo CEP Início obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <label for="cepfim">CEP Final</label>
              <div class="position-relative">
                <input id="cepfim" type="text" v-model="baseOrigemData.cepfim" class="form-control"
                       placeholder="CEP Final" :class="{ 'is-invalid': submittedBaseOrigem && !baseOrigemData.cepfim }" />
                <div v-if="submittedBaseOrigem && !baseOrigemData.cepfim" class="invalid-feedback">
                  <span>Campo CEP Final obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalBaseOrigem = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button variant="outline-danger"
                    v-if="baseOrigemData && baseOrigemData.id > 0"
                    class="ms-1" @click="exclBaseOrigem(baseOrigemData.id)">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Excluir
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confBaseOrigem">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>





    <b-modal size="lg"
             title="Criando / Editando Taxa Peso"
             v-model="showModalTxPeso" centered hide-footer>
      <div>
        <div class="card-body">


          <div class="row mb-2">

            <div class="col-md-9">
              <label for="ceppesodestino">Destino</label>
              <div class="position-relative">
                <input id="ceppesodestino" type="text" v-model="txPesoData.destino" class="form-control"
                       placeholder="Destino" :class="{ 'is-invalid': submittedTxPeso && !txPesoData.destino }" />
                <div v-if="submittedTxPeso && !txPesoData.destino" class="invalid-feedback">
                  <span>Campo destino obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <label for="ceppesoestado">Estado</label>
              <div class="position-relative">
                <input id="ceppesoestado" type="text" v-model="txPesoData.estado" class="form-control"
                       placeholder="Estado" :class="{ 'is-invalid': submittedTxPeso && !txPesoData.estado }" />
                <div v-if="submittedTxPeso && !txPesoData.estado" class="invalid-feedback">
                  <span>Campo Estado obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

          </div>

          <div class="row mb-2">


            <div class="col-md-6">
              <label for="ceppesocepini">CEP Início</label>
              <div class="position-relative">
                <input id="ceppesocepini" type="number" v-model="txPesoData.cepini" class="form-control"
                       placeholder="CEP Início" :class="{ 'is-invalid': submittedTxPeso && !txPesoData.cepini }" />
                <div v-if="submittedTxPeso && !txPesoData.cepini" class="invalid-feedback">
                  <span>Campo CEP Início obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <label for="ceppesocepfim">CEP Fim</label>
              <div class="position-relative">
                <input id="ceppesocepfim" type="number" v-model="txPesoData.cepfim" class="form-control"
                       placeholder="CEP Fim" :class="{ 'is-invalid': submittedTxPeso && !txPesoData.cepfim }" />
                <div v-if="submittedTxPeso && !txPesoData.cepfim" class="invalid-feedback">
                  <span>Campo CEP Fim obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

          </div>




          <div class="row mb-3">

            <div class="col-md-6">
              <label for="valorexced">Valor Peso Excedente (R$)</label>
              <div class="position-relative">
                <input id="valorexced" type="number" v-model="txPesoData.valorexced" class="form-control"
                       placeholder="Valor Peso Excedente (R$)"/>
              </div>
            </div>

            <div class="col-md-6">
              <label for="valoradic">Valor Peso Adicional (R$)</label>
              <div class="position-relative">
                <input id="valoradic" type="number" v-model="txPesoData.valoradic" class="form-control"
                       placeholder="Valor Peso Adicional (R$)"/>
              </div>
            </div>

          </div>



          <div class="row mb-2 mt-4">
            <hr>
            <h4 class="card-title">Detalhes Faixas de Pesos</h4>
          </div>



          <div class="row mb-2" v-for="data in txPesoData.txpesos" :key="data.pesoini">


            <div class="col-md-3">
              <label for="ceppesopesoini">Peso Início</label>
              <div class="position-relative">
                <input id="ceppesopesoini" type="number" v-model="data.pesoini" class="form-control"
                       placeholder="Peso Início" :class="{ 'is-invalid': submittedFxPesoTxPeso && !data.pesoini }" />
                <div v-if="submittedFxPesoTxPeso && !data.pesoini" class="invalid-feedback">
                  <span>Campo Peso Início obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <label for="ceppesopesofim">Peso Fim</label>
              <div class="position-relative">
                <input id="ceppesopesofim" type="number" v-model="data.pesofim" class="form-control"
                       placeholder="Peso Fim" :class="{ 'is-invalid': submittedFxPesoTxPeso && !data.pesofim }" />
                <div v-if="submittedFxPesoTxPeso && !data.pesofim" class="invalid-feedback">
                  <span>Campo Peso Fim obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <label for="ceppesovalor">Valor R$</label>
              <div class="position-relative">
                <input id="ceppesovalor" type="number" v-model="data.valor" class="form-control"
                       placeholder="Valor R$" :class="{ 'is-invalid': submittedFxPesoTxPeso && !data.valor }" />
                <div v-if="submittedFxPesoTxPeso && !data.valor" class="invalid-feedback">
                  <span>Campo Valor obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>


            <div class="col-md-3 d-flex align-items-end justify-content-end">

              <b-button variant="outline-danger"
                        class="ms-1" @click="exclTxPeso(data.pesoini)">
                <i class="bx bx-trash font-size-16 align-middle me-2"></i>
                Excluir
              </b-button>

            </div>

          </div>



        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalTxPeso = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>


          <b-button variant="outline-info"
                    class="ms-1" @click="novaFxPesoTxPeso()">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            Nova Faixa de Peso
          </b-button>


          <b-button type="submit" variant="success" class="ms-1" @click="confTxPeso">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>



  </Layout>
</template>